"use strict";
/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.5.0 (NJsonSchema v10.6.6.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionResponseOfOrder = exports.CollectionResponseOfBuilding = exports.MobilePaymentType = exports.MenuItemOptionGroup = exports.MenuItemOption = exports.MenuItemDb = exports.Menu = exports.MealPeriodType = exports.MealPeriod = exports.MealCardBalanceInfo = exports.MarketLocation = exports.ItemType = exports.HoursOfOperation = exports.GeographyPointLocation = exports.SubStatusCode = exports.OrderStatusUpdateEvent = exports.Espresso = exports.OnlineAvailabilityCapability = exports.ImageType = exports.MobilePaymentDto = exports.CheckPaymentDto = exports.CardPaymentDto = exports.DistanceUnit = exports.UploadImageResponse = exports.DraftMenu = exports.DraftCafeStationsSchedule = exports.DraftCafeStationWeeklyMenuSchedule = exports.DraftCafeStation = exports.DraftAllergen = exports.CurrencyInfo = exports.Country = exports.Coordinates = exports.CommunicationStatusResponse = exports.ChoiceGroupType = exports.CartStatus = exports.CartItem = exports.CartIssueType = exports.CartIssue = exports.Cart = exports.CafeServiceItem = exports.CafeProfile = exports.CafeImageCollection = exports.CafeCalendarItem = exports.Cafe = exports.Building = exports.SupportedNetwork = exports.SupportedMethod = exports.PaymentMethod = exports.Allergen = exports.ApiClient = void 0;
exports.ApiException = exports.DayOfWeek = exports.Location = exports.FoodStallUpdate = exports.FoodStallSchedule = exports.FoodStallResponse = exports.FoodStallCreate = exports.SubStatusCode2 = exports.ErrorResponse2 = exports.CafeConfigResponse = exports.Pricing2 = exports.PatchOrderRequest = exports.OnlineMenuItem = exports.OnlineMenu = exports.MenuItemOptionGroup2 = exports.MenuItemOption2 = exports.MenuItem = exports.Menu2 = exports.ItemType2 = exports.Allergen2 = exports.ErrorResponse = exports.MenuType = exports.StationViewModel = exports.CafeListItemViewModel = exports.UserFavorite = exports.Timezone = exports.Timeslot = exports.Station = exports.Schedule = exports.RegionCafeListItem = exports.Region = exports.Pricing = exports.PingResponse = exports.PickupTimeslots = exports.PaymentConfiguration = exports.Payment = exports.OrderStatus = exports.OrderItem = exports.Order = exports.CollectionResponseOfOnlineMenu = exports.CollectionResponseOfStationViewModel = exports.CollectionResponseOfCafeListItemViewModel = void 0;
var ApiClient = /** @class */ (function () {
    function ApiClient(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://dev-dining-api-westus.azurewebsites.net";
    }
    /**
     * Get all buildings.
     * @param top (optional) The number of buildings to retrieve.
     * @param skip (optional) The number of buildings to skip.
     * @param countryCode (optional) The country code with which to filter results by.
     * @param api_version (optional) The requested API version
     * @return Buildings successfully retrieved.
     */
    ApiClient.prototype.getAllBuildings = function (top, skip, countryCode, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/building?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (countryCode === null)
            throw new Error("The parameter 'countryCode' cannot be null.");
        else if (countryCode !== undefined)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetAllBuildings(_response);
        });
    };
    ApiClient.prototype.processGetAllBuildings = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_1 = resultData200; _i < resultData200_1.length; _i++) {
                        var item = resultData200_1[_i];
                        result200.push(Building.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Get buildings by Id.
     * @param id Building guid.
     * @param api_version (optional) The requested API version
     * @return Building successfully retrieved.
     */
    ApiClient.prototype.getBuildingById = function (id, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/building/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetBuildingById(_response);
        });
    };
    ApiClient.prototype.processGetBuildingById = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Building.fromJS(resultData200);
                return result200;
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Gets dining information for buildings that have dining services.
     * @param top (optional) specifies how many results to return.
     * @param skip (optional) specifies how many results to skip.
     * @param api_version (optional) The requested API version
     * @return Dining information successfully retrieved.
     */
    ApiClient.prototype.getBuildingsWithDiningInformation = function (top, skip, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/building/dining?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetBuildingsWithDiningInformation(_response);
        });
    };
    ApiClient.prototype.processGetBuildingsWithDiningInformation = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CollectionResponseOfBuilding.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("Unauthorized", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("Forbidden", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Get buildings by LegacyBuildingId.
     * @param legacyBuildingId Legacy Building Id.
     * @param api_version (optional) The requested API version
     * @return Building by legacy id successfully retrieved.
     */
    ApiClient.prototype.getByLegacyBuildingId = function (legacyBuildingId, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/building/legacybuildingid/{legacyBuildingId}?";
        if (legacyBuildingId === undefined || legacyBuildingId === null)
            throw new Error("The parameter 'legacyBuildingId' must be defined.");
        url_ = url_.replace("{legacyBuildingId}", encodeURIComponent("" + legacyBuildingId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetByLegacyBuildingId(_response);
        });
    };
    ApiClient.prototype.processGetByLegacyBuildingId = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Building.fromJS(resultData200);
                return result200;
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Flush cache.
     * @param api_version (optional) The requested API version
     * @return cache flushed successfully.
     */
    ApiClient.prototype.flushCache = function (api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/cache/flush?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processFlushCache(_response);
        });
    };
    ApiClient.prototype.processFlushCache = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Flush all partially matched cached keys.
     * @param key part of the key.
     * @param api_version (optional) The requested API version
     * @return cache with partial match flushed successfully.
     */
    ApiClient.prototype.flushCacheWithPartialMatch = function (key, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/cache/flushcachewithpartialmatch?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined and cannot be null.");
        else
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processFlushCacheWithPartialMatch(_response);
        });
    };
    ApiClient.prototype.processFlushCacheWithPartialMatch = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Gets cafe configs.
     * @param top (optional) The number of cafe configs to get.
     * @param skip (optional) The number of cafe configs to skip.
     * @param api_version (optional) The requested API version
     * @return Cafe configs successfully retrieved.
     */
    ApiClient.prototype.getCafeConfigs = function (top, skip, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/cafeconfigs?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetCafeConfigs(_response);
        });
    };
    ApiClient.prototype.processGetCafeConfigs = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_2 = resultData200; _i < resultData200_2.length; _i++) {
                        var item = resultData200_2[_i];
                        result200.push(CafeConfigResponse.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("Unauthorized access blocked.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse2.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Syncs cafe config.
     * @param api_version (optional) The requested API version
     * @return Cafe config synced successfully.
     */
    ApiClient.prototype.syncCafeConfig = function (cafeConfigId, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/cafeconfigs/{cafeConfigId}/sync?";
        if (cafeConfigId === undefined || cafeConfigId === null)
            throw new Error("The parameter 'cafeConfigId' must be defined.");
        url_ = url_.replace("{cafeConfigId}", encodeURIComponent("" + cafeConfigId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processSyncCafeConfig(_response);
        });
    };
    ApiClient.prototype.processSyncCafeConfig = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_3 = resultData200; _i < resultData200_3.length; _i++) {
                        var item = resultData200_3[_i];
                        result200.push(CommunicationStatusResponse.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("Unauthorized access blocked.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse2.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Gets a list of cafes.
     * @param top (optional) The number of cafes to retrieve.
     * @param skip (optional) The number of cafes to skip.
     * @param countryCode (optional) The country code with which to filter results by.
     * @param lat (optional) The latiude of the user's location to filter results by.
     * @param lon (optional) The longitude of the user's location to filter results by.
     * @param radius (optional) The distance within we want all returned results to be within.
     * @param distanceUnit (optional) The unit of measure that the radius is specified in.
     * @param onlineAvailabilityCapability (optional) The level of online availability capability of a cafe.
     * @param buildingId (optional) The building Id to filter results by.
     * @param api_version (optional) The requested API version
     * @return Cafes successfully retrieved.
     */
    ApiClient.prototype.getCafesList = function (top, skip, countryCode, lat, lon, radius, distanceUnit, onlineAvailabilityCapability, buildingId, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/cafes/list?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (countryCode === null)
            throw new Error("The parameter 'countryCode' cannot be null.");
        else if (countryCode !== undefined)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (lat === null)
            throw new Error("The parameter 'lat' cannot be null.");
        else if (lat !== undefined)
            url_ += "lat=" + encodeURIComponent("" + lat) + "&";
        if (lon === null)
            throw new Error("The parameter 'lon' cannot be null.");
        else if (lon !== undefined)
            url_ += "lon=" + encodeURIComponent("" + lon) + "&";
        if (radius === null)
            throw new Error("The parameter 'radius' cannot be null.");
        else if (radius !== undefined)
            url_ += "radius=" + encodeURIComponent("" + radius) + "&";
        if (distanceUnit === null)
            throw new Error("The parameter 'distanceUnit' cannot be null.");
        else if (distanceUnit !== undefined)
            url_ += "distanceUnit=" + encodeURIComponent("" + distanceUnit) + "&";
        if (onlineAvailabilityCapability === null)
            throw new Error("The parameter 'onlineAvailabilityCapability' cannot be null.");
        else if (onlineAvailabilityCapability !== undefined)
            url_ += "onlineAvailabilityCapability=" + encodeURIComponent("" + onlineAvailabilityCapability) + "&";
        if (buildingId === null)
            throw new Error("The parameter 'buildingId' cannot be null.");
        else if (buildingId !== undefined)
            url_ += "buildingId=" + encodeURIComponent("" + buildingId) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetCafesList(_response);
        });
    };
    ApiClient.prototype.processGetCafesList = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CollectionResponseOfCafeListItemViewModel.fromJS(resultData200);
                return result200;
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Gets a list of cafes. Please use the cafes/list endpoint instead.
     * @param top (optional) The number of cafes to retrieve.
     * @param skip (optional) The number of cafes to skip.
     * @param api_version (optional) The requested API version
     * @return Cafes successfully retrieved.
     * @deprecated
     */
    ApiClient.prototype.getCafes = function (top, skip, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/cafes?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetCafes(_response);
        });
    };
    ApiClient.prototype.processGetCafes = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_4 = resultData200; _i < resultData200_4.length; _i++) {
                        var item = resultData200_4[_i];
                        result200.push(Cafe.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Gets the nearest cafe given a latitude, longitude, and maximum radius.
     * @param lat (optional) The latiude of the user's location to filter results by.
     * @param lon (optional) The longitude of the user's location to filter results by.
     * @param radius (optional) The maximum distance the nearest cafe will be filtered by.
     * @param distanceUnit (optional) The unit of measure that the radius is specified in.
     * @param api_version (optional) The requested API version
     * @return Nearest cafes successfully retrieved.
     */
    ApiClient.prototype.nearest = function (lat, lon, radius, distanceUnit, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/cafes/nearest?";
        if (lat === null)
            throw new Error("The parameter 'lat' cannot be null.");
        else if (lat !== undefined)
            url_ += "lat=" + encodeURIComponent("" + lat) + "&";
        if (lon === null)
            throw new Error("The parameter 'lon' cannot be null.");
        else if (lon !== undefined)
            url_ += "lon=" + encodeURIComponent("" + lon) + "&";
        if (radius === null)
            throw new Error("The parameter 'radius' cannot be null.");
        else if (radius !== undefined)
            url_ += "radius=" + encodeURIComponent("" + radius) + "&";
        if (distanceUnit === null)
            throw new Error("The parameter 'distanceUnit' cannot be null.");
        else if (distanceUnit !== undefined)
            url_ += "distanceUnit=" + encodeURIComponent("" + distanceUnit) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processNearest(_response);
        });
    };
    ApiClient.prototype.processNearest = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CafeListItemViewModel.fromJS(resultData200);
                return result200;
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Gets a list of stations in the cafe.
     * @param cafeId The id of the cafe.
     * @param dayOfWeek (optional) day of week (optional).
     * @param api_version (optional) The requested API version
     * @return Stations successfully retrieved.
     */
    ApiClient.prototype.getCafeStationsList = function (cafeId, dayOfWeek, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/cafes/{cafeId}/stations/list?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (dayOfWeek === null)
            throw new Error("The parameter 'dayOfWeek' cannot be null.");
        else if (dayOfWeek !== undefined)
            url_ += "dayOfWeek=" + encodeURIComponent("" + dayOfWeek) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetCafeStationsList(_response);
        });
    };
    ApiClient.prototype.processGetCafeStationsList = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CollectionResponseOfStationViewModel.fromJS(resultData200);
                return result200;
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Gets a cafe.
     * @param cafeId The id of the cafe.
     * @param api_version (optional) The requested API version
     * @return Cafe successfully retrieved.
     * @deprecated
     */
    ApiClient.prototype.getCafe = function (cafeId, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/cafes/{cafeId}?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetCafe(_response);
        });
    };
    ApiClient.prototype.processGetCafe = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Cafe.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                return throwException("Cafe not found.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Gets a cafe by Id.
     * @param cafeId The id of the cafe.
     * @param api_version (optional) The requested API version
     * @return Cafe successfully retrieved.
     */
    ApiClient.prototype.getCafeById = function (cafeId, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/cafes/id/{cafeId}?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetCafeById(_response);
        });
    };
    ApiClient.prototype.processGetCafeById = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CafeListItemViewModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                return throwException("Cafe not found.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Gets a cafe stations schedule boundaries.
     * @param cafeId Cafe Id.
     * @param api_version (optional) The requested API version
     * @return Cafe stations schedule successfully retrieved.
     */
    ApiClient.prototype.getCafeStationsSchedule = function (cafeId, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/cafes/{cafeId}/stations/schedule?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetCafeStationsSchedule(_response);
        });
    };
    ApiClient.prototype.processGetCafeStationsSchedule = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_5 = resultData200; _i < resultData200_5.length; _i++) {
                        var item = resultData200_5[_i];
                        result200.push(item);
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Get cafe images for a given cafe.
     * @param cafeId Cafe Id.
     * @param api_version (optional) The requested API version
     * @return Cafe images successfully retrieved.
     */
    ApiClient.prototype.getCafeImages = function (cafeId, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/cafes/{cafeId}/images?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetCafeImages(_response);
        });
    };
    ApiClient.prototype.processGetCafeImages = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Gets the menus on the station that are available for online ordering right now.
     * @param cafeId The id of the cafe.
     * @param stationId The id of the station.
     * @param api_version (optional) The requested API version
     * @return Cafe station menu right now successfully retrieved.
     */
    ApiClient.prototype.getCafeStationMenusRightNow = function (cafeId, stationId, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/cafes/{cafeId}/stations/{stationId}/menus/now?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (stationId === undefined || stationId === null)
            throw new Error("The parameter 'stationId' must be defined.");
        url_ = url_.replace("{stationId}", encodeURIComponent("" + stationId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetCafeStationMenusRightNow(_response);
        });
    };
    ApiClient.prototype.processGetCafeStationMenusRightNow = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CollectionResponseOfOnlineMenu.fromJS(resultData200);
                return result200;
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Gets the menus on the cafe for for today.
     * @param cafeId The id of the cafe.
     * @param api_version (optional) The requested API version
     * @return Menu for today successfully retrieved.
     */
    ApiClient.prototype.getMenusForToday = function (cafeId, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/cafes/{cafeId}/menus/today?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetMenusForToday(_response);
        });
    };
    ApiClient.prototype.processGetMenusForToday = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_6 = resultData200; _i < resultData200_6.length; _i++) {
                        var item = resultData200_6[_i];
                        result200.push(Menu2.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Gets the menus on the cafe for weekday.
    Day of week. Starts with Sunday = 0, to Saturday = 6.
     * @param cafeId The id of the cafe.
     * @param dayOfWeek Day of week.
     * @param api_version (optional) The requested API version
     * @return Menu for day of week successfully retrieved.
     */
    ApiClient.prototype.getMenusForDayOfWeek = function (cafeId, dayOfWeek, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/cafes/{cafeId}/menus/{dayOfWeek}?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (dayOfWeek === undefined || dayOfWeek === null)
            throw new Error("The parameter 'dayOfWeek' must be defined.");
        url_ = url_.replace("{dayOfWeek}", encodeURIComponent("" + dayOfWeek));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetMenusForDayOfWeek(_response);
        });
    };
    ApiClient.prototype.processGetMenusForDayOfWeek = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_7 = resultData200; _i < resultData200_7.length; _i++) {
                        var item = resultData200_7[_i];
                        result200.push(Menu2.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Gets the menus on the station (inclusive of whether the item is available to order online or not) for weekday.
    Day of week. Starts with Sunday = 0, to Saturday = 6.
     * @param cafeId The id of the cafe.
     * @param stationId stationId.
     * @param dayOfWeek Day of week.
     * @param api_version (optional) The requested API version
     * @return Menu for day of week successfully retrieved.
     */
    ApiClient.prototype.getStationFullMenusForDayOfWeek = function (cafeId, stationId, dayOfWeek, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/cafes/{cafeId}/stations/{stationId}/fullmenus/{dayOfWeek}?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (stationId === undefined || stationId === null)
            throw new Error("The parameter 'stationId' must be defined.");
        url_ = url_.replace("{stationId}", encodeURIComponent("" + stationId));
        if (dayOfWeek === undefined || dayOfWeek === null)
            throw new Error("The parameter 'dayOfWeek' must be defined.");
        url_ = url_.replace("{dayOfWeek}", encodeURIComponent("" + dayOfWeek));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetStationFullMenusForDayOfWeek(_response);
        });
    };
    ApiClient.prototype.processGetStationFullMenusForDayOfWeek = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CollectionResponseOfOnlineMenu.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Gets the menus on the cafe for the week.
     * @param cafeId The id of the cafe.
     * @param menuType (optional) The menu type to grab: either online, offline, or either.
     * @param api_version (optional) The requested API version
     * @return Menu for week successfully retrieved.
     */
    ApiClient.prototype.getMenusForWeek = function (cafeId, menuType, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/cafes/{cafeId}/stations/all/menus/week?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (menuType === null)
            throw new Error("The parameter 'menuType' cannot be null.");
        else if (menuType !== undefined)
            url_ += "menuType=" + encodeURIComponent("" + menuType) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetMenusForWeek(_response);
        });
    };
    ApiClient.prototype.processGetMenusForWeek = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_8 = resultData200; _i < resultData200_8.length; _i++) {
                        var item = resultData200_8[_i];
                        result200.push(Menu2.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Adds an item to a cart.
     * @param cafeId The id of the cafe.
     * @param api_version (optional) The requested API version
     * @param body (optional) The cart item to add to the cart.
     * @return Add item to cart successfully.
     */
    ApiClient.prototype.addItemToCafeCart = function (cafeId, api_version, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/cafes/{cafeId}/cart/items?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processAddItemToCafeCart(_response);
        });
    };
    ApiClient.prototype.processAddItemToCafeCart = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Cart.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else if (status === 422) {
            return response.text().then(function (_responseText) {
                return throwException("Unprocessable request.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Removes an item from the active cart.
     * @param cafeId The id of the cafe.
     * @param itemId The id of the cart item.
     * @param api_version (optional) The requested API version
     * @return remove item from cart successfully.
     */
    ApiClient.prototype.removeItemFromCafeCart = function (cafeId, itemId, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/cafes/{cafeId}/cart/items/{itemId}?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processRemoveItemFromCafeCart(_response);
        });
    };
    ApiClient.prototype.processRemoveItemFromCafeCart = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Cart.fromJS(resultData200);
                return result200;
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Edits an item in the active cart.
     * @param cafeId The id of the cafe.
     * @param itemId The id of the cart item to be deleted.
     * @param api_version (optional) The requested API version
     * @param body (optional) The cart item to edit/add in the cart.
     * @return Edit item to station's cart successfully.
     */
    ApiClient.prototype.editItemInCafeCart = function (cafeId, itemId, api_version, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/cafes/{cafeId}/cart/items/{itemId}?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processEditItemInCafeCart(_response);
        });
    };
    ApiClient.prototype.processEditItemInCafeCart = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Cart.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Checkouts a cart.
     * @param cafeId The id of the cafe.
     * @param api_version (optional) The requested API version
     * @return Checkout successfully.
     */
    ApiClient.prototype.checkoutCafeCart = function (cafeId, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/cafes/{cafeId}/cart/checkout?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processCheckoutCafeCart(_response);
        });
    };
    ApiClient.prototype.processCheckoutCafeCart = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Cart.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Pay for a checked out cart with a mobile payment.
     * @param api_version (optional) The requested API version
     * @param body (optional) Mobile payment information.
     * @return Pay with Mobile successfully.
     */
    ApiClient.prototype.payWithMobile = function (api_version, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/cafes/cart/payments/mobile?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processPayWithMobile(_response);
        });
    };
    ApiClient.prototype.processPayWithMobile = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Order.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else if (status === 422) {
            return response.text().then(function (_responseText) {
                return throwException("Unprocessable request.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Pay for a checked out cart with a card.
     * @param api_version (optional) The requested API version
     * @param body (optional) Card information.
     * @return Pay with Card successfully.
     */
    ApiClient.prototype.payWithCard = function (api_version, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/cafes/cart/payments/card?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processPayWithCard(_response);
        });
    };
    ApiClient.prototype.processPayWithCard = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Order.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else if (status === 422) {
            return response.text().then(function (_responseText) {
                return throwException("Unprocessable request.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Check payment status and create order.
     * @param api_version (optional) The requested API version
     * @param body (optional) Card information.
     * @return Success
     * @deprecated
     */
    ApiClient.prototype.checkCardPayment = function (api_version, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/cafes/cart/payments/check?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processCheckCardPayment(_response);
        });
    };
    ApiClient.prototype.processCheckCardPayment = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Order.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 422) {
            return response.text().then(function (_responseText) {
                var result422 = null;
                var resultData422 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result422 = ErrorResponse.fromJS(resultData422);
                return throwException("Client Error", status, _responseText, _headers, result422);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Favorite a station.
     * @param cafeId The id of the cafe.
     * @param stationId The id of the station.
     * @param api_version (optional) The requested API version
     * @return Add favorite station successfully.
     */
    ApiClient.prototype.addFavoriteStation = function (cafeId, stationId, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/cafes/{cafeId}/stations/{stationId}/favorite?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (stationId === undefined || stationId === null)
            throw new Error("The parameter 'stationId' must be defined.");
        url_ = url_.replace("{stationId}", encodeURIComponent("" + stationId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processAddFavoriteStation(_response);
        });
    };
    ApiClient.prototype.processAddFavoriteStation = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Unfavorite a station.
     * @param cafeId The id of the cafe.
     * @param stationId The id of the station.
     * @param api_version (optional) The requested API version
     * @return Remove favorite station successfully.
     */
    ApiClient.prototype.removeFavoriteStation = function (cafeId, stationId, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/cafes/{cafeId}/stations/{stationId}/unfavorite?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (stationId === undefined || stationId === null)
            throw new Error("The parameter 'stationId' must be defined.");
        url_ = url_.replace("{stationId}", encodeURIComponent("" + stationId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processRemoveFavoriteStation(_response);
        });
    };
    ApiClient.prototype.processRemoveFavoriteStation = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Set isDecommission flag for a cafe.
     * @param cafeId Cafe Id.
     * @param isDecommissioned (optional) IsDecommissioned flag.
     * @param api_version (optional) The requested API version
     * @return Updated cafe's isDecommission flag  successfully.
     */
    ApiClient.prototype.decommissionCafe = function (cafeId, isDecommissioned, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/cafes/{cafeId}/decommission?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (isDecommissioned === null)
            throw new Error("The parameter 'isDecommissioned' cannot be null.");
        else if (isDecommissioned !== undefined)
            url_ += "isDecommissioned=" + encodeURIComponent("" + isDecommissioned) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "PATCH",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processDecommissionCafe(_response);
        });
    };
    ApiClient.prototype.processDecommissionCafe = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                return throwException("Server error.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Set Cafe hours of operation.
     * @param cafeId cafeId for a cafe
     * @param api_version (optional) The requested API version
     * @param body (optional) mealPeriod for a given cafe.
     * @return Set cafe hours of operation successfully.
     */
    ApiClient.prototype.hoursofoperation = function (cafeId, api_version, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/cafes/{cafeId}/hoursofoperation?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processHoursofoperation(_response);
        });
    };
    ApiClient.prototype.processHoursofoperation = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                return throwException("Server error.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Bulk set cafe and cafe profile disclaimers by cafeIds.
     * @param disclaimer (optional) disclaimer Infomation.
     * @param api_version (optional) The requested API version
     * @param body (optional) cafeIds
     * @return bulk set cafe and cafe profile disclaimers successfully.
     */
    ApiClient.prototype.disclaimers = function (disclaimer, api_version, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/cafes/cafeids/disclaimers?";
        if (disclaimer === null)
            throw new Error("The parameter 'disclaimer' cannot be null.");
        else if (disclaimer !== undefined)
            url_ += "disclaimer=" + encodeURIComponent("" + disclaimer) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processDisclaimers(_response);
        });
    };
    ApiClient.prototype.processDisclaimers = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                return throwException("Server error.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Bulk set cafe and cafe profile disclaimers by vendorId.
     * @param vendorId vendorId
     * @param disclaimer (optional) disclaimer Infomation.
     * @param api_version (optional) The requested API version
     * @return bulk set cafe and cafe profile disclaimers successfully.
     */
    ApiClient.prototype.disclaimers2 = function (vendorId, disclaimer, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/cafes/vendors/{vendorId}/disclaimers?";
        if (vendorId === undefined || vendorId === null)
            throw new Error("The parameter 'vendorId' must be defined.");
        url_ = url_.replace("{vendorId}", encodeURIComponent("" + vendorId));
        if (disclaimer === null)
            throw new Error("The parameter 'disclaimer' cannot be null.");
        else if (disclaimer !== undefined)
            url_ += "disclaimer=" + encodeURIComponent("" + disclaimer) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processDisclaimers2(_response);
        });
    };
    ApiClient.prototype.processDisclaimers2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                return throwException("Server error.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Set cafes and their stations' IsOnlyForBetaUsers flag.
     * @param isOnlyForBetaUsers (optional) isOnlyForBetaUsers.
     * @param api_version (optional) The requested API version
     * @param body (optional) cafeIds.
     * @return Set cafes and their stations' IsOnlyForBetaUsers flags successfully.
     */
    ApiClient.prototype.isonlyforbetausers = function (isOnlyForBetaUsers, api_version, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/cafes/cafeids/isonlyforbetausers?";
        if (isOnlyForBetaUsers === null)
            throw new Error("The parameter 'isOnlyForBetaUsers' cannot be null.");
        else if (isOnlyForBetaUsers !== undefined)
            url_ += "isOnlyForBetaUsers=" + encodeURIComponent("" + isOnlyForBetaUsers) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processIsonlyforbetausers(_response);
        });
    };
    ApiClient.prototype.processIsonlyforbetausers = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 207) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                return throwException("Server error.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Place an order with the same items as per the given orderId from past orders.
     * @param orderId The Id of the order.
     * @param api_version (optional) The requested API version
     * @param body (optional) Card information.
     * @return Reorder successfully.
     */
    ApiClient.prototype.reOrder = function (orderId, api_version, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/cafes/profiles/me/orders/{orderId}/reorder?";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processReOrder(_response);
        });
    };
    ApiClient.prototype.processReOrder = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Order.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                return throwException("Order not found.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Sync cafe and flush cache for a given cafe id.
     * @param cafeId cafeIds.
     * @param api_version (optional) The requested API version
     * @return Cafe successfully synced.
     */
    ApiClient.prototype.syncCafeId = function (cafeId, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/cafesync/{cafeId}?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processSyncCafeId(_response);
        });
    };
    ApiClient.prototype.processSyncCafeId = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_9 = resultData200; _i < resultData200_9.length; _i++) {
                        var item = resultData200_9[_i];
                        result200.push(CommunicationStatusResponse.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("Unauthorized access blocked.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse2.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Gets payment configuration.
     * @param api_version (optional) The requested API version
     * @return Retrieve payment configuration successfully.
     */
    ApiClient.prototype.getPaymentConfig = function (api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/configuration/payment?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetPaymentConfig(_response);
        });
    };
    ApiClient.prototype.processGetPaymentConfig = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PaymentConfiguration.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 204) {
            return response.text().then(function (_responseText) {
                return throwException("Payment config not found.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Set a station's IsOnlyForBetaUsers flag (only for updating config).
     * @param cafeConfigId cafeConfigId.
     * @param stationConfigId stationConfigId.
     * @param isOnlyForBetaUsers (optional) isOnlyForBetaUsers.
     * @param api_version (optional) The requested API version
     * @return Set a station's IsOnlyForBetaUsers flag successfully.
     */
    ApiClient.prototype.isonlyforbetausers2 = function (cafeConfigId, stationConfigId, isOnlyForBetaUsers, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/configuration/{cafeConfigId}/stationconfigs/{stationConfigId}/isonlyforbetausers?";
        if (cafeConfigId === undefined || cafeConfigId === null)
            throw new Error("The parameter 'cafeConfigId' must be defined.");
        url_ = url_.replace("{cafeConfigId}", encodeURIComponent("" + cafeConfigId));
        if (stationConfigId === undefined || stationConfigId === null)
            throw new Error("The parameter 'stationConfigId' must be defined.");
        url_ = url_.replace("{stationConfigId}", encodeURIComponent("" + stationConfigId));
        if (isOnlyForBetaUsers === null)
            throw new Error("The parameter 'isOnlyForBetaUsers' cannot be null.");
        else if (isOnlyForBetaUsers !== undefined)
            url_ += "isOnlyForBetaUsers=" + encodeURIComponent("" + isOnlyForBetaUsers) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processIsonlyforbetausers2(_response);
        });
    };
    ApiClient.prototype.processIsonlyforbetausers2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                return throwException("Server error.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Gets the cart details for the user.
     * @param api_version (optional) The requested API version
     * @return Retrieved Cart successfully.
     */
    ApiClient.prototype.getCart = function (api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/customers/me/cart?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetCart(_response);
        });
    };
    ApiClient.prototype.processGetCart = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Cart.fromJS(resultData200);
                return result200;
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Abandon a cart.
     * @param api_version (optional) The requested API version
     * @return Abandon user cart successfully.
     */
    ApiClient.prototype.abandonCart = function (api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/customers/me/cart/abandon?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processAbandonCart(_response);
        });
    };
    ApiClient.prototype.processAbandonCart = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 202) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Api completes the order pickup
    Precondition: Order's status should be ReadyForPickup
    Returns NotFound if the order does not exist
    Returns BadRequest If the order's status is not valid.
     * @param orderId The order identifier.
     * @param api_version (optional) The requested API version
     * @return Complete order pickup successfully.
     */
    ApiClient.prototype.completeOrderPickup = function (orderId, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/customers/me/order/{orderId}/completepickup?";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "PATCH",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processCompleteOrderPickup(_response);
        });
    };
    ApiClient.prototype.processCompleteOrderPickup = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 202) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Modifies the order. Currently this only supports order status.
     * @param orderId The order identifier.
     * @param api_version (optional) The requested API version
     * @param body (optional) The request to modify order.
     * @return Patch order successfully.
     */
    ApiClient.prototype.patchOrder = function (orderId, api_version, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/customers/me/order/{orderId}?";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processPatchOrder(_response);
        });
    };
    ApiClient.prototype.processPatchOrder = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 202) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Gets the active order details.
     * @param api_version (optional) The requested API version
     * @return Get active order successfully.
     */
    ApiClient.prototype.getActiveOrder = function (api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/customers/me/orders/active?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetActiveOrder(_response);
        });
    };
    ApiClient.prototype.processGetActiveOrder = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Order.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Get currently active orders for the user.
     * @param api_version (optional) The requested API version
     * @return Get currently active orders for the user successfully.
     */
    ApiClient.prototype.getActiveOrdersList = function (api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/customers/me/orders/active/list?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetActiveOrdersList(_response);
        });
    };
    ApiClient.prototype.processGetActiveOrdersList = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CollectionResponseOfOrder.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Create a cafe for a given region.
     * @param body Cafe information.
     * @param regionId (optional) Region Id.
     * @param api_version (optional) The requested API version
     * @return Cafe successfully created.
     */
    ApiClient.prototype.createCafe = function (body, regionId, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/diningtool/cafes?";
        if (regionId === null)
            throw new Error("The parameter 'regionId' cannot be null.");
        else if (regionId !== undefined)
            url_ += "regionId=" + encodeURIComponent("" + regionId) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processCreateCafe(_response);
        });
    };
    ApiClient.prototype.processCreateCafe = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Cafe.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Add a station to a given cafe.
     * @param cafeId Cafe Id.
     * @param name Station name.
     * @param api_version (optional) The requested API version
     * @return Station successfully created.
     */
    ApiClient.prototype.addStation = function (cafeId, name, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/diningtool/cafes/{cafeId}/stations/{name}?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processAddStation(_response);
        });
    };
    ApiClient.prototype.processAddStation = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Station.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                return throwException("Server Error.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Delete a station to a given cafe.
     * @param cafeId Cafe Id.
     * @param stationId Station Id.
     * @param api_version (optional) The requested API version
     * @return Station successfully deleted.
     */
    ApiClient.prototype.deleteStation = function (cafeId, stationId, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/diningtool/cafes/{cafeId}/stations/{stationId}?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (stationId === undefined || stationId === null)
            throw new Error("The parameter 'stationId' must be defined.");
        url_ = url_.replace("{stationId}", encodeURIComponent("" + stationId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processDeleteStation(_response);
        });
    };
    ApiClient.prototype.processDeleteStation = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Station.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                return throwException("Server Error.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Rename a station to a given cafe.
     * @param cafeId Cafe Id.
     * @param stationId Station Id.
     * @param newName New name for station.
     * @param api_version (optional) The requested API version
     * @return Station rename successfully.
     */
    ApiClient.prototype.renameStation = function (cafeId, stationId, newName, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/diningtool/cafes/{cafeId}/stations/{stationId}/name/{newName}?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (stationId === undefined || stationId === null)
            throw new Error("The parameter 'stationId' must be defined.");
        url_ = url_.replace("{stationId}", encodeURIComponent("" + stationId));
        if (newName === undefined || newName === null)
            throw new Error("The parameter 'newName' must be defined.");
        url_ = url_.replace("{newName}", encodeURIComponent("" + newName));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processRenameStation(_response);
        });
    };
    ApiClient.prototype.processRenameStation = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = Station.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                return throwException("Server Error.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Get cafes list for a particular region.
     * @param regionId Region Id.
     * @param vendorName (optional) Vendor Name.
     * @param api_version (optional) The requested API version
     * @return Cafes by region Id successfully retreived.
     */
    ApiClient.prototype.getCafesByRegionId = function (regionId, vendorName, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/diningtool/cafes/{regionId}?";
        if (regionId === undefined || regionId === null)
            throw new Error("The parameter 'regionId' must be defined.");
        url_ = url_.replace("{regionId}", encodeURIComponent("" + regionId));
        if (vendorName === null)
            throw new Error("The parameter 'vendorName' cannot be null.");
        else if (vendorName !== undefined)
            url_ += "vendorName=" + encodeURIComponent("" + vendorName) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetCafesByRegionId(_response);
        });
    };
    ApiClient.prototype.processGetCafesByRegionId = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_10 = resultData200; _i < resultData200_10.length; _i++) {
                        var item = resultData200_10[_i];
                        result200.push(RegionCafeListItem.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                return throwException("Server Error.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Get a cafe's weekly schedule.
     * @param cafeId Cafe Id.
     * @param weekStart Week start.
     * @param api_version (optional) The requested API version
     * @return Cafe's week schedule retreived successfully.
     */
    ApiClient.prototype.getCafeWeeklySchedule = function (cafeId, weekStart, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/diningtool/cafes/{cafeId}/draftcafeschedules/{weekStart}?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (weekStart === undefined || weekStart === null)
            throw new Error("The parameter 'weekStart' must be defined.");
        url_ = url_.replace("{weekStart}", encodeURIComponent("" + weekStart));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetCafeWeeklySchedule(_response);
        });
    };
    ApiClient.prototype.processGetCafeWeeklySchedule = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = DraftCafeStationWeeklyMenuSchedule.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                return throwException("Cafe not found.", status, _responseText, _headers);
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                return throwException("Server Error.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Delete draft cafe schedule saved for a cafe.
     * @param cafeId Cafe Id.
     * @param weekStart Week start date.
     * @param api_version (optional) The requested API version
     * @return Delete draft cafe week schedule completed successfully.
     */
    ApiClient.prototype.deleteDraftCafeStationWeekSchedule = function (cafeId, weekStart, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/diningtool/cafes/{cafeId}/draftcafeschedules/{weekStart}?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (weekStart === undefined || weekStart === null)
            throw new Error("The parameter 'weekStart' must be defined.");
        url_ = url_.replace("{weekStart}", encodeURIComponent("" + weekStart));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processDeleteDraftCafeStationWeekSchedule(_response);
        });
    };
    ApiClient.prototype.processDeleteDraftCafeStationWeekSchedule = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                return throwException("Cafe not found.", status, _responseText, _headers);
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                return throwException("Server Error.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Add or update draft cafe's weekly schedule.
     * @param cafeId Cafe Id.
     * @param body Cafe schedule.
     * @param api_version (optional) The requested API version
     * @return Add/Update of Cafe week schedule completed successfully.
     */
    ApiClient.prototype.addOrUpdateCafeStationWeekSchedule = function (cafeId, body, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/diningtool/cafes/{cafeId}/draftcafeschedules?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processAddOrUpdateCafeStationWeekSchedule(_response);
        });
    };
    ApiClient.prototype.processAddOrUpdateCafeStationWeekSchedule = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = DraftCafeStationsSchedule.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                return throwException("Cafe not found.", status, _responseText, _headers);
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                return throwException("Server Error.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Save a cafe's weekly schedule.
     * @param cafeId Cafe Id.
     * @param startDate Start date.
     * @param api_version (optional) The requested API version
     * @return Publish Cafe week schedule completed successfully.
     */
    ApiClient.prototype.publishCafeWeeklySchedule = function (cafeId, startDate, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/diningtool/cafes/{cafeId}/draftcafeschedules/{startDate}?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined.");
        url_ = url_.replace("{startDate}", encodeURIComponent("" + startDate));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processPublishCafeWeeklySchedule(_response);
        });
    };
    ApiClient.prototype.processPublishCafeWeeklySchedule = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then(function (_responseText) {
                return throwException("Cafe not found.", status, _responseText, _headers);
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                return throwException("Server Error.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Upload images for cafe.
     * @param api_version (optional) The requested API version
     * @param file (optional)
     * @return Success
     */
    ApiClient.prototype.uploadImageForCafe = function (cafeId, api_version, file) {
        var _this = this;
        var url_ = this.baseUrl + "/api/diningtool/cafes/{cafeId}/image?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processUploadImageForCafe(_response);
        });
    };
    ApiClient.prototype.processUploadImageForCafe = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                var resultData500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result500 = ErrorResponse.fromJS(resultData500);
                return throwException("Server Error", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Delete cafe images.
     * @param api_version (optional) The requested API version
     * @return Success
     */
    ApiClient.prototype.deleteImageForCafe = function (cafeId, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/diningtool/cafes/{cafeId}/image?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processDeleteImageForCafe(_response);
        });
    };
    ApiClient.prototype.processDeleteImageForCafe = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                var resultData500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result500 = ErrorResponse.fromJS(resultData500);
                return throwException("Server Error", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Upload images for menu item.
     * @param api_version (optional) The requested API version
     * @param file (optional)
     * @return Success
     */
    ApiClient.prototype.uploadImageForMenuItem = function (cafeId, stationId, menuItemId, api_version, file) {
        var _this = this;
        var url_ = this.baseUrl + "/api/diningtool/cafes/{cafeId}/stations/{stationId}/menus/{menuItemId}/image?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (stationId === undefined || stationId === null)
            throw new Error("The parameter 'stationId' must be defined.");
        url_ = url_.replace("{stationId}", encodeURIComponent("" + stationId));
        if (menuItemId === undefined || menuItemId === null)
            throw new Error("The parameter 'menuItemId' must be defined.");
        url_ = url_.replace("{menuItemId}", encodeURIComponent("" + menuItemId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processUploadImageForMenuItem(_response);
        });
    };
    ApiClient.prototype.processUploadImageForMenuItem = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = UploadImageResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                var resultData500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result500 = ErrorResponse.fromJS(resultData500);
                return throwException("Server Error", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Delete menu item images.
     * @param api_version (optional) The requested API version
     * @return Success
     */
    ApiClient.prototype.deleteImageForMenuItem = function (cafeId, stationId, menuItemId, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/diningtool/cafes/{cafeId}/stations/{stationId}/menus/{menuItemId}/image?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (stationId === undefined || stationId === null)
            throw new Error("The parameter 'stationId' must be defined.");
        url_ = url_.replace("{stationId}", encodeURIComponent("" + stationId));
        if (menuItemId === undefined || menuItemId === null)
            throw new Error("The parameter 'menuItemId' must be defined.");
        url_ = url_.replace("{menuItemId}", encodeURIComponent("" + menuItemId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processDeleteImageForMenuItem(_response);
        });
    };
    ApiClient.prototype.processDeleteImageForMenuItem = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                var result500 = null;
                var resultData500 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result500 = ErrorResponse.fromJS(resultData500);
                return throwException("Server Error", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Delete image by URL.
     * @param imageUrl (optional)
     * @param api_version (optional) The requested API version
     * @return Success
     */
    ApiClient.prototype.deleteImageByUrl = function (imageType, imageUrl, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/diningtool/images/{imageType}?";
        if (imageType === undefined || imageType === null)
            throw new Error("The parameter 'imageType' must be defined.");
        url_ = url_.replace("{imageType}", encodeURIComponent("" + imageType));
        if (imageUrl === null)
            throw new Error("The parameter 'imageUrl' cannot be null.");
        else if (imageUrl !== undefined)
            url_ += "imageUrl=" + encodeURIComponent("" + imageUrl) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processDeleteImageByUrl(_response);
        });
    };
    ApiClient.prototype.processDeleteImageByUrl = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Get all the allergens for a a given cafe.
     * @param cafeId Cafe Id.
     * @param api_version (optional) The requested API version
     * @return List of allergens.
     */
    ApiClient.prototype.getAllergens = function (cafeId, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/diningtool/cafes/{cafeId}/allergens?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetAllergens(_response);
        });
    };
    ApiClient.prototype.processGetAllergens = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_11 = resultData200; _i < resultData200_11.length; _i++) {
                        var item = resultData200_11[_i];
                        result200.push(DraftAllergen.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Get menu bank  for the given cafe's station.
     * @param cafeId Cafe Id.
     * @param stationId Station Id.
     * @param api_version (optional) The requested API version
     * @return List of menu bank items for given stationid.
     */
    ApiClient.prototype.getMenuBankForStation = function (cafeId, stationId, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/diningtool/cafes/{cafeId}/stations/{stationId}/menubank/items?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (stationId === undefined || stationId === null)
            throw new Error("The parameter 'stationId' must be defined.");
        url_ = url_.replace("{stationId}", encodeURIComponent("" + stationId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetMenuBankForStation(_response);
        });
    };
    ApiClient.prototype.processGetMenuBankForStation = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_12 = resultData200; _i < resultData200_12.length; _i++) {
                        var item = resultData200_12[_i];
                        result200.push(MenuItemDb.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Add or Update menu item to menu bank for the given cafe's station.
     * @param cafeId Cafe Id.
     * @param stationId Station Id.
     * @param body Menu item.
     * @param api_version (optional) The requested API version
     * @return Menu item was added/ updated in the menu bank  for the given cafe's station.
     */
    ApiClient.prototype.addUpdateMenuItemInMenuBank = function (cafeId, stationId, body, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/diningtool/cafes/{cafeId}/stations/{stationId}/menubank/items?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (stationId === undefined || stationId === null)
            throw new Error("The parameter 'stationId' must be defined.");
        url_ = url_.replace("{stationId}", encodeURIComponent("" + stationId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processAddUpdateMenuItemInMenuBank(_response);
        });
    };
    ApiClient.prototype.processAddUpdateMenuItemInMenuBank = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = MenuItemDb.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Get menu item for the given id.
     * @param cafeId Cafe Id.
     * @param stationId Station Id.
     * @param menuItemId Menu item Id.
     * @param api_version (optional) The requested API version
     * @return Menu item by Id.
     */
    ApiClient.prototype.getMenuItemFromMenuBank = function (cafeId, stationId, menuItemId, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/diningtool/cafes/{cafeId}/stations/{stationId}/menubank/item/{menuItemId}?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (stationId === undefined || stationId === null)
            throw new Error("The parameter 'stationId' must be defined.");
        url_ = url_.replace("{stationId}", encodeURIComponent("" + stationId));
        if (menuItemId === undefined || menuItemId === null)
            throw new Error("The parameter 'menuItemId' must be defined.");
        url_ = url_.replace("{menuItemId}", encodeURIComponent("" + menuItemId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetMenuItemFromMenuBank(_response);
        });
    };
    ApiClient.prototype.processGetMenuItemFromMenuBank = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = MenuItemDb.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Delete menu item from menu bank for the given cafe's station.
     * @param cafeId cafe Id.
     * @param stationId Station Id.
     * @param menuItemId Menu item Id.
     * @param api_version (optional) The requested API version
     * @return Menu item was deleted from menu tool for the given cafe's station.
     */
    ApiClient.prototype.deleteMenuItemFromMenuBank = function (cafeId, stationId, menuItemId, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/diningtool/cafes/{cafeId}/stations/{stationId}/menubank/items/{menuItemId}?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (stationId === undefined || stationId === null)
            throw new Error("The parameter 'stationId' must be defined.");
        url_ = url_.replace("{stationId}", encodeURIComponent("" + stationId));
        if (menuItemId === undefined || menuItemId === null)
            throw new Error("The parameter 'menuItemId' must be defined.");
        url_ = url_.replace("{menuItemId}", encodeURIComponent("" + menuItemId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processDeleteMenuItemFromMenuBank(_response);
        });
    };
    ApiClient.prototype.processDeleteMenuItemFromMenuBank = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Gets a list of foodstall.
     * @param top (optional) The number of foodstalls to retrieve.
     * @param skip (optional) The number of foodstalls to skip.
     * @param api_version (optional) The requested API version
     * @return Foodstalls successfully retrieved.
     */
    ApiClient.prototype.getFoodStalls = function (top, skip, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/foodstalls?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetFoodStalls(_response);
        });
    };
    ApiClient.prototype.processGetFoodStalls = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_13 = resultData200; _i < resultData200_13.length; _i++) {
                        var item = resultData200_13[_i];
                        result200.push(FoodStallResponse.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse2.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Create a foodstall.
     * @param body Foodstall information.
     * @param api_version (optional) The requested API version
     * @return Foodstall successfully created.
     */
    ApiClient.prototype.createFoodStall = function (body, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/foodstalls?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processCreateFoodStall(_response);
        });
    };
    ApiClient.prototype.processCreateFoodStall = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FoodStallResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse2.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * @param api_version (optional) The requested API version
     * @return Accepted
     */
    ApiClient.prototype.updateFoodStall = function (foodStallId, body, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/foodstalls/{foodStallId}?";
        if (foodStallId === undefined || foodStallId === null)
            throw new Error("The parameter 'foodStallId' must be defined.");
        url_ = url_.replace("{foodStallId}", encodeURIComponent("" + foodStallId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processUpdateFoodStall(_response);
        });
    };
    ApiClient.prototype.processUpdateFoodStall = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 202) {
            return response.text().then(function (_responseText) {
                var result202 = null;
                var resultData202 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result202 = FoodStallResponse.fromJS(resultData202);
                return result202;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ErrorResponse2.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * Delete a foodstall.
     * @param foodStallId The id of the foodstall.
     * @param api_version (optional) The requested API version
     * @return Foodstall successfully deleted.
     */
    ApiClient.prototype.deleteFoodStall = function (foodStallId, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/foodstalls/{foodStallId}?";
        if (foodStallId === undefined || foodStallId === null)
            throw new Error("The parameter 'foodStallId' must be defined.");
        url_ = url_.replace("{foodStallId}", encodeURIComponent("" + foodStallId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processDeleteFoodStall(_response);
        });
    };
    ApiClient.prototype.processDeleteFoodStall = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 202) {
            return response.text().then(function (_responseText) {
                var result202 = null;
                var resultData202 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result202 = ErrorResponse2.fromJS(resultData202);
                return result202;
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse2.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Pings the health of the Dining API and its dependencies.
     * @param checkDependencies (optional)
     * @param api_version (optional) The requested API version
     * @return Pinged successfully.
     */
    ApiClient.prototype.healthCheckPing = function (checkDependencies, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/health/ping?";
        if (checkDependencies === null)
            throw new Error("The parameter 'checkDependencies' cannot be null.");
        else if (checkDependencies !== undefined)
            url_ += "checkDependencies=" + encodeURIComponent("" + checkDependencies) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processHealthCheckPing(_response);
        });
    };
    ApiClient.prototype.processHealthCheckPing = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PingResponse.fromJS(resultData200);
                return result200;
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Returns Mealcard balance.
     * @param api_version (optional) The requested API version
     * @return Gets meal card balance successfully.
     */
    ApiClient.prototype.getMealCardBalance = function (api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/mealcardbalance?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetMealCardBalance(_response);
        });
    };
    ApiClient.prototype.processGetMealCardBalance = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = MealCardBalanceInfo.fromJS(resultData200);
                return result200;
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Get all regions.
     * @param top (optional) The number of regions to retrieve.
     * @param skip (optional) The number of regions to skip.
     * @param api_version (optional) The requested API version
     * @return Regions successfully retrieved.
     */
    ApiClient.prototype.getAllRegions = function (top, skip, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/regions?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetAllRegions(_response);
        });
    };
    ApiClient.prototype.processGetAllRegions = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_14 = resultData200; _i < resultData200_14.length; _i++) {
                        var item = resultData200_14[_i];
                        result200.push(Region.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Upload an image.
     * @param cafeId Cafe Id.
     * @param stationId Station Id.
     * @param api_version (optional) The requested API version
     * @param file (optional)
     * @return image uploaded successfully.
     */
    ApiClient.prototype.uploadImage = function (cafeId, stationId, api_version, file) {
        var _this = this;
        var url_ = this.baseUrl + "/api/cafes/{cafeId}/stations/{stationId}/images?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (stationId === undefined || stationId === null)
            throw new Error("The parameter 'stationId' must be defined.");
        url_ = url_.replace("{stationId}", encodeURIComponent("" + stationId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        var options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processUploadImage(_response);
        });
    };
    ApiClient.prototype.processUploadImage = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 201) {
            return response.text().then(function (_responseText) {
                var result201 = null;
                var resultData201 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null;
                return result201;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Deletes station image.
     * @param cafeId The id of the cafe.
     * @param stationId The id of the station.
     * @param api_version (optional) The requested API version
     * @return Image deleted successfully.
     */
    ApiClient.prototype.deleteImage = function (cafeId, stationId, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/cafes/{cafeId}/stations/{stationId}/images?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (stationId === undefined || stationId === null)
            throw new Error("The parameter 'stationId' must be defined.");
        url_ = url_.replace("{stationId}", encodeURIComponent("" + stationId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processDeleteImage(_response);
        });
    };
    ApiClient.prototype.processDeleteImage = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then(function (_responseText) {
                return throwException("Bad request.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Get past orders.
     * @param top (optional) The number of cafes to retrieve.
     * @param api_version (optional) The requested API version
     * @return Retreived user's past orders successfully.
     */
    ApiClient.prototype.getOrders = function (top, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/users/orders?";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetOrders(_response);
        });
    };
    ApiClient.prototype.processGetOrders = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_15 = resultData200; _i < resultData200_15.length; _i++) {
                        var item = resultData200_15[_i];
                        result200.push(Order.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                return throwException("Server error.", status, _responseText, _headers);
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("Unauthorized.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Get favorite food stalls.
     * @param api_version (optional) The requested API version
     * @return Retreived user's favorite foostrucks successfully.
     */
    ApiClient.prototype.getFavoriteFoodStalls = function (api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/users/foodstalls/favorites?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetFavoriteFoodStalls(_response);
        });
    };
    ApiClient.prototype.processGetFavoriteFoodStalls = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_16 = resultData200; _i < resultData200_16.length; _i++) {
                        var item = resultData200_16[_i];
                        result200.push(UserFavorite.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                return throwException("Server error.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Update favorite food trucks.
     * @param foodStallId Foodstall Id.
     * @param isFavorite (optional) IsFavorite flag.
     * @param api_version (optional) The requested API version
     * @return Updated user's favorite foodstall successfully.
     */
    ApiClient.prototype.addOrRemoveFavoriteFoodStall = function (foodStallId, isFavorite, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/users/foodstalls/favorites/{foodStallId}?";
        if (foodStallId === undefined || foodStallId === null)
            throw new Error("The parameter 'foodStallId' must be defined.");
        url_ = url_.replace("{foodStallId}", encodeURIComponent("" + foodStallId));
        if (isFavorite === null)
            throw new Error("The parameter 'isFavorite' cannot be null.");
        else if (isFavorite !== undefined)
            url_ += "isFavorite=" + encodeURIComponent("" + isFavorite) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "PATCH",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processAddOrRemoveFavoriteFoodStall(_response);
        });
    };
    ApiClient.prototype.processAddOrRemoveFavoriteFoodStall = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                return throwException("Server error.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Get favorite cafes.
     * @param api_version (optional) The requested API version
     * @return Retreived user's favorite cafes successfully.
     */
    ApiClient.prototype.getFavoriteCafes = function (api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/users/cafes/favorites?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetFavoriteCafes(_response);
        });
    };
    ApiClient.prototype.processGetFavoriteCafes = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CollectionResponseOfCafeListItemViewModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                return throwException("Server error.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Update favorite cafe.
     * @param cafeId Cafe Id.
     * @param isFavorited (optional) IsFavorite flag.
     * @param api_version (optional) The requested API version
     * @return Updated user's favorite cafe successfully.
     */
    ApiClient.prototype.updateFavoriteCafe = function (cafeId, isFavorited, api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/v2/users/cafes/favorites/{cafeId}?";
        if (cafeId === undefined || cafeId === null)
            throw new Error("The parameter 'cafeId' must be defined.");
        url_ = url_.replace("{cafeId}", encodeURIComponent("" + cafeId));
        if (isFavorited === null)
            throw new Error("The parameter 'isFavorited' cannot be null.");
        else if (isFavorited !== undefined)
            url_ += "isFavorited=" + encodeURIComponent("" + isFavorited) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "PATCH",
            headers: {}
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processUpdateFavoriteCafe(_response);
        });
    };
    ApiClient.prototype.processUpdateFavoriteCafe = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 500) {
            return response.text().then(function (_responseText) {
                return throwException("Server error.", status, _responseText, _headers);
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    /**
     * Gets application build version.
     * @param api_version (optional) The requested API version
     * @return Retreived build version successfully.
     */
    ApiClient.prototype.getVersion = function (api_version) {
        var _this = this;
        var url_ = this.baseUrl + "/api/version?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.processGetVersion(_response);
        });
    };
    ApiClient.prototype.processGetVersion = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else {
            return response.text().then(function (_responseText) {
                var resultdefault = null;
                var resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                resultdefault = ErrorResponse.fromJS(resultDatadefault);
                return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    };
    return ApiClient;
}());
exports.ApiClient = ApiClient;
var Allergen = /** @class */ (function () {
    function Allergen(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Allergen.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.optional = _data["optional"];
        }
    };
    Allergen.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Allergen();
        result.init(data);
        return result;
    };
    Allergen.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["optional"] = this.optional;
        return data;
    };
    return Allergen;
}());
exports.Allergen = Allergen;
var PaymentMethod = /** @class */ (function () {
    function PaymentMethod(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaymentMethod.prototype.init = function (_data) {
        if (_data) {
            this.method = _data["method"];
            this.active = _data["active"];
        }
    };
    PaymentMethod.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaymentMethod();
        result.init(data);
        return result;
    };
    PaymentMethod.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["method"] = this.method;
        data["active"] = this.active;
        return data;
    };
    return PaymentMethod;
}());
exports.PaymentMethod = PaymentMethod;
var SupportedMethod = /** @class */ (function () {
    function SupportedMethod(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SupportedMethod.prototype.init = function (_data) {
        if (_data) {
            this.method = _data["method"];
        }
    };
    SupportedMethod.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SupportedMethod();
        result.init(data);
        return result;
    };
    SupportedMethod.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["method"] = this.method;
        return data;
    };
    return SupportedMethod;
}());
exports.SupportedMethod = SupportedMethod;
var SupportedNetwork = /** @class */ (function () {
    function SupportedNetwork(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SupportedNetwork.prototype.init = function (_data) {
        if (_data) {
            this.network = _data["network"];
            this.active = _data["active"];
        }
    };
    SupportedNetwork.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SupportedNetwork();
        result.init(data);
        return result;
    };
    SupportedNetwork.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["network"] = this.network;
        data["active"] = this.active;
        return data;
    };
    return SupportedNetwork;
}());
exports.SupportedNetwork = SupportedNetwork;
var Building = /** @class */ (function () {
    function Building(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.location = new GeographyPointLocation();
        }
    }
    Building.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.location = _data["location"] ? GeographyPointLocation.fromJS(_data["location"]) : new GeographyPointLocation();
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.addressLine3 = _data["addressLine3"];
            this.cityName = _data["cityName"];
            this.countryCode = _data["countryCode"];
            this.countryName = _data["countryName"];
            this.stateOrProvinceCode = _data["stateOrProvinceCode"];
            this.stateOrProvinceName = _data["stateOrProvinceName"];
            this.postalCode = _data["postalCode"];
            this.campusId = _data["campusId"];
            this.buildingId = _data["buildingId"];
            this.physicalRegionId = _data["physicalRegionId"];
            this.timezone = _data["timezone"] ? Timezone.fromJS(_data["timezone"]) : undefined;
            if (Array.isArray(_data["cafes"])) {
                this.cafes = [];
                for (var _i = 0, _a = _data["cafes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.cafes.push(Cafe.fromJS(item));
                }
            }
            if (Array.isArray(_data["cafeProfiles"])) {
                this.cafeProfiles = [];
                for (var _b = 0, _c = _data["cafeProfiles"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.cafeProfiles.push(CafeProfile.fromJS(item));
                }
            }
            if (Array.isArray(_data["marketLocation"])) {
                this.marketLocation = [];
                for (var _d = 0, _e = _data["marketLocation"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.marketLocation.push(MarketLocation.fromJS(item));
                }
            }
            if (Array.isArray(_data["espresso"])) {
                this.espresso = [];
                for (var _f = 0, _g = _data["espresso"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.espresso.push(Espresso.fromJS(item));
                }
            }
            this.timeStamp = _data["timeStamp"];
        }
    };
    Building.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Building();
        result.init(data);
        return result;
    };
    Building.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["location"] = this.location ? this.location.toJSON() : undefined;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["addressLine3"] = this.addressLine3;
        data["cityName"] = this.cityName;
        data["countryCode"] = this.countryCode;
        data["countryName"] = this.countryName;
        data["stateOrProvinceCode"] = this.stateOrProvinceCode;
        data["stateOrProvinceName"] = this.stateOrProvinceName;
        data["postalCode"] = this.postalCode;
        data["campusId"] = this.campusId;
        data["buildingId"] = this.buildingId;
        data["physicalRegionId"] = this.physicalRegionId;
        data["timezone"] = this.timezone ? this.timezone.toJSON() : undefined;
        if (Array.isArray(this.cafes)) {
            data["cafes"] = [];
            for (var _i = 0, _a = this.cafes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["cafes"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.cafeProfiles)) {
            data["cafeProfiles"] = [];
            for (var _b = 0, _c = this.cafeProfiles; _b < _c.length; _b++) {
                var item = _c[_b];
                data["cafeProfiles"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.marketLocation)) {
            data["marketLocation"] = [];
            for (var _d = 0, _e = this.marketLocation; _d < _e.length; _d++) {
                var item = _e[_d];
                data["marketLocation"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.espresso)) {
            data["espresso"] = [];
            for (var _f = 0, _g = this.espresso; _f < _g.length; _f++) {
                var item = _g[_f];
                data["espresso"].push(item.toJSON());
            }
        }
        data["timeStamp"] = this.timeStamp;
        return data;
    };
    return Building;
}());
exports.Building = Building;
var Cafe = /** @class */ (function () {
    function Cafe(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.location = new GeographyPointLocation();
            this.stations = [];
        }
    }
    Cafe.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.buildingId = _data["buildingId"];
            this.buildingName = _data["buildingName"];
            if (Array.isArray(_data["calendar"])) {
                this.calendar = [];
                for (var _i = 0, _a = _data["calendar"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.calendar.push(CafeCalendarItem.fromJS(item));
                }
            }
            this.canPurchaseItemsOnline = _data["canPurchaseItemsOnline"];
            this.countryCode = _data["countryCode"];
            this.cafeHours = _data["cafeHours"];
            if (Array.isArray(_data["hoursOfOperation"])) {
                this.hoursOfOperation = [];
                for (var _b = 0, _c = _data["hoursOfOperation"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.hoursOfOperation.push(HoursOfOperation.fromJS(item));
                }
            }
            this.imageUrl = _data["imageUrl"];
            this.currencyInfo = _data["currencyInfo"] ? CurrencyInfo.fromJS(_data["currencyInfo"]) : undefined;
            this.endsOn = _data["endsOn"];
            this.ianaTimezoneId = _data["ianaTimezoneId"];
            this.images = _data["images"] ? CafeImageCollection.fromJS(_data["images"]) : undefined;
            this.legacyBuildingId = _data["legacyBuildingId"];
            this.location = _data["location"] ? GeographyPointLocation.fromJS(_data["location"]) : new GeographyPointLocation();
            this.cafeId = _data["cafeId"];
            this.name = _data["name"];
            this.region = _data["region"] ? Region.fromJS(_data["region"]) : undefined;
            this.regionId = _data["regionId"];
            this.isOnlyForBetaUsers = _data["isOnlyForBetaUsers"];
            this.serviceHours = _data["serviceHours"];
            if (Array.isArray(_data["mealPeriods"])) {
                this.mealPeriods = [];
                for (var _d = 0, _e = _data["mealPeriods"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.mealPeriods.push(MealPeriod.fromJS(item));
                }
            }
            this.startsOn = _data["startsOn"];
            if (Array.isArray(_data["stations"])) {
                this.stations = [];
                for (var _f = 0, _g = _data["stations"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.stations.push(Station.fromJS(item));
                }
            }
            this.disclaimer = _data["disclaimer"];
            this.currencyName = _data["currencyName"];
            this.currencySymbol = _data["currencySymbol"];
            this.profitCenterId = _data["profitCenterId"];
            this.storeId = _data["storeId"];
            this.terminalId = _data["terminalId"];
            this.url = _data["url"];
            this.vendorId = _data["vendorId"];
            this.vendorSourceRecordId = _data["vendorSourceRecordId"];
            this.pickupTimeslots = _data["pickupTimeslots"] ? PickupTimeslots.fromJS(_data["pickupTimeslots"]) : undefined;
            this.timeStamp = _data["timeStamp"];
        }
    };
    Cafe.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Cafe();
        result.init(data);
        return result;
    };
    Cafe.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["buildingId"] = this.buildingId;
        data["buildingName"] = this.buildingName;
        if (Array.isArray(this.calendar)) {
            data["calendar"] = [];
            for (var _i = 0, _a = this.calendar; _i < _a.length; _i++) {
                var item = _a[_i];
                data["calendar"].push(item.toJSON());
            }
        }
        data["canPurchaseItemsOnline"] = this.canPurchaseItemsOnline;
        data["countryCode"] = this.countryCode;
        data["cafeHours"] = this.cafeHours;
        if (Array.isArray(this.hoursOfOperation)) {
            data["hoursOfOperation"] = [];
            for (var _b = 0, _c = this.hoursOfOperation; _b < _c.length; _b++) {
                var item = _c[_b];
                data["hoursOfOperation"].push(item.toJSON());
            }
        }
        data["imageUrl"] = this.imageUrl;
        data["currencyInfo"] = this.currencyInfo ? this.currencyInfo.toJSON() : undefined;
        data["endsOn"] = this.endsOn;
        data["ianaTimezoneId"] = this.ianaTimezoneId;
        data["images"] = this.images ? this.images.toJSON() : undefined;
        data["legacyBuildingId"] = this.legacyBuildingId;
        data["location"] = this.location ? this.location.toJSON() : undefined;
        data["cafeId"] = this.cafeId;
        data["name"] = this.name;
        data["region"] = this.region ? this.region.toJSON() : undefined;
        data["regionId"] = this.regionId;
        data["isOnlyForBetaUsers"] = this.isOnlyForBetaUsers;
        data["serviceHours"] = this.serviceHours;
        if (Array.isArray(this.mealPeriods)) {
            data["mealPeriods"] = [];
            for (var _d = 0, _e = this.mealPeriods; _d < _e.length; _d++) {
                var item = _e[_d];
                data["mealPeriods"].push(item.toJSON());
            }
        }
        data["startsOn"] = this.startsOn;
        if (Array.isArray(this.stations)) {
            data["stations"] = [];
            for (var _f = 0, _g = this.stations; _f < _g.length; _f++) {
                var item = _g[_f];
                data["stations"].push(item.toJSON());
            }
        }
        data["disclaimer"] = this.disclaimer;
        data["currencyName"] = this.currencyName;
        data["currencySymbol"] = this.currencySymbol;
        data["profitCenterId"] = this.profitCenterId;
        data["storeId"] = this.storeId;
        data["terminalId"] = this.terminalId;
        data["url"] = this.url;
        data["vendorId"] = this.vendorId;
        data["vendorSourceRecordId"] = this.vendorSourceRecordId;
        data["pickupTimeslots"] = this.pickupTimeslots ? this.pickupTimeslots.toJSON() : undefined;
        data["timeStamp"] = this.timeStamp;
        return data;
    };
    return Cafe;
}());
exports.Cafe = Cafe;
var CafeCalendarItem = /** @class */ (function () {
    function CafeCalendarItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.services = [];
        }
    }
    CafeCalendarItem.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.dayOfWeek = _data["dayOfWeek"];
            if (Array.isArray(_data["services"])) {
                this.services = [];
                for (var _i = 0, _a = _data["services"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.services.push(CafeServiceItem.fromJS(item));
                }
            }
            this.status = _data["status"];
        }
    };
    CafeCalendarItem.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CafeCalendarItem();
        result.init(data);
        return result;
    };
    CafeCalendarItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dayOfWeek"] = this.dayOfWeek;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (var _i = 0, _a = this.services; _i < _a.length; _i++) {
                var item = _a[_i];
                data["services"].push(item.toJSON());
            }
        }
        data["status"] = this.status;
        return data;
    };
    return CafeCalendarItem;
}());
exports.CafeCalendarItem = CafeCalendarItem;
var CafeImageCollection = /** @class */ (function () {
    function CafeImageCollection(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CafeImageCollection.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.headerWeb = _data["headerWeb"];
            this.headerMobile = _data["headerMobile"];
            this.scaled1x = _data["scaled1x"];
            this.scaled2x = _data["scaled2x"];
            this.scaled3x = _data["scaled3x"];
            this.scaled4x = _data["scaled4x"];
            this.scaled5x = _data["scaled5x"];
        }
    };
    CafeImageCollection.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CafeImageCollection();
        result.init(data);
        return result;
    };
    CafeImageCollection.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["headerWeb"] = this.headerWeb;
        data["headerMobile"] = this.headerMobile;
        data["scaled1x"] = this.scaled1x;
        data["scaled2x"] = this.scaled2x;
        data["scaled3x"] = this.scaled3x;
        data["scaled4x"] = this.scaled4x;
        data["scaled5x"] = this.scaled5x;
        return data;
    };
    return CafeImageCollection;
}());
exports.CafeImageCollection = CafeImageCollection;
var CafeProfile = /** @class */ (function () {
    function CafeProfile(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.location = new GeographyPointLocation();
        }
    }
    CafeProfile.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.buildingId = _data["buildingId"];
            this.buildingName = _data["buildingName"];
            this.canPurchaseItemsOnline = _data["canPurchaseItemsOnline"];
            this.countryCode = _data["countryCode"];
            this.cafeHours = _data["cafeHours"];
            if (Array.isArray(_data["hoursOfOperation"])) {
                this.hoursOfOperation = [];
                for (var _i = 0, _a = _data["hoursOfOperation"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.hoursOfOperation.push(HoursOfOperation.fromJS(item));
                }
            }
            this.imageUrl = _data["imageUrl"];
            this.currencyInfo = _data["currencyInfo"] ? CurrencyInfo.fromJS(_data["currencyInfo"]) : undefined;
            this.ianaTimezoneId = _data["ianaTimezoneId"];
            this.legacyBuildingId = _data["legacyBuildingId"];
            this.location = _data["location"] ? GeographyPointLocation.fromJS(_data["location"]) : new GeographyPointLocation();
            this.cafeId = _data["cafeId"];
            this.name = _data["name"];
            this.region = _data["region"] ? Region.fromJS(_data["region"]) : undefined;
            this.regionId = _data["regionId"];
            this.isOnlyForBetaUsers = _data["isOnlyForBetaUsers"];
            this.serviceHours = _data["serviceHours"];
            if (Array.isArray(_data["mealPeriods"])) {
                this.mealPeriods = [];
                for (var _b = 0, _c = _data["mealPeriods"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.mealPeriods.push(MealPeriod.fromJS(item));
                }
            }
            this.disclaimer = _data["disclaimer"];
            this.currencyName = _data["currencyName"];
            this.currencySymbol = _data["currencySymbol"];
            this.profitCenterId = _data["profitCenterId"];
            this.terminalId = _data["terminalId"];
            this.url = _data["url"];
            this.vendorId = _data["vendorId"];
            this.vendorSourceRecordId = _data["vendorSourceRecordId"];
            this.pickupTimeslots = _data["pickupTimeslots"] ? PickupTimeslots.fromJS(_data["pickupTimeslots"]) : undefined;
            this.isDecommissioned = _data["isDecommissioned"];
            this.timeStamp = _data["timeStamp"];
        }
    };
    CafeProfile.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CafeProfile();
        result.init(data);
        return result;
    };
    CafeProfile.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["buildingId"] = this.buildingId;
        data["buildingName"] = this.buildingName;
        data["canPurchaseItemsOnline"] = this.canPurchaseItemsOnline;
        data["countryCode"] = this.countryCode;
        data["cafeHours"] = this.cafeHours;
        if (Array.isArray(this.hoursOfOperation)) {
            data["hoursOfOperation"] = [];
            for (var _i = 0, _a = this.hoursOfOperation; _i < _a.length; _i++) {
                var item = _a[_i];
                data["hoursOfOperation"].push(item.toJSON());
            }
        }
        data["imageUrl"] = this.imageUrl;
        data["currencyInfo"] = this.currencyInfo ? this.currencyInfo.toJSON() : undefined;
        data["ianaTimezoneId"] = this.ianaTimezoneId;
        data["legacyBuildingId"] = this.legacyBuildingId;
        data["location"] = this.location ? this.location.toJSON() : undefined;
        data["cafeId"] = this.cafeId;
        data["name"] = this.name;
        data["region"] = this.region ? this.region.toJSON() : undefined;
        data["regionId"] = this.regionId;
        data["isOnlyForBetaUsers"] = this.isOnlyForBetaUsers;
        data["serviceHours"] = this.serviceHours;
        if (Array.isArray(this.mealPeriods)) {
            data["mealPeriods"] = [];
            for (var _b = 0, _c = this.mealPeriods; _b < _c.length; _b++) {
                var item = _c[_b];
                data["mealPeriods"].push(item.toJSON());
            }
        }
        data["disclaimer"] = this.disclaimer;
        data["currencyName"] = this.currencyName;
        data["currencySymbol"] = this.currencySymbol;
        data["profitCenterId"] = this.profitCenterId;
        data["terminalId"] = this.terminalId;
        data["url"] = this.url;
        data["vendorId"] = this.vendorId;
        data["vendorSourceRecordId"] = this.vendorSourceRecordId;
        data["pickupTimeslots"] = this.pickupTimeslots ? this.pickupTimeslots.toJSON() : undefined;
        data["isDecommissioned"] = this.isDecommissioned;
        data["timeStamp"] = this.timeStamp;
        return data;
    };
    return CafeProfile;
}());
exports.CafeProfile = CafeProfile;
var CafeServiceItem = /** @class */ (function () {
    function CafeServiceItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CafeServiceItem.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isAvailable = _data["isAvailable"];
            this.hours = _data["hours"];
        }
    };
    CafeServiceItem.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CafeServiceItem();
        result.init(data);
        return result;
    };
    CafeServiceItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isAvailable"] = this.isAvailable;
        data["hours"] = this.hours;
        return data;
    };
    return CafeServiceItem;
}());
exports.CafeServiceItem = CafeServiceItem;
var Cart = /** @class */ (function () {
    function Cart(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.items = [];
            this.subTotalAmount = new Pricing();
            this.taxAmount = new Pricing();
            this.totalAmount = new Pricing();
        }
    }
    Cart.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.userAlias = _data["userAlias"];
            this.cafeId = _data["cafeId"];
            this.cafeName = _data["cafeName"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(CartItem.fromJS(item));
                }
            }
            this.status = _data["status"];
            if (Array.isArray(_data["issues"])) {
                this.issues = [];
                for (var _b = 0, _c = _data["issues"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.issues.push(CartIssue.fromJS(item));
                }
            }
            this.subTotalAmount = _data["subTotalAmount"] ? Pricing.fromJS(_data["subTotalAmount"]) : new Pricing();
            this.taxAmount = _data["taxAmount"] ? Pricing.fromJS(_data["taxAmount"]) : new Pricing();
            this.totalAmount = _data["totalAmount"] ? Pricing.fromJS(_data["totalAmount"]) : new Pricing();
            this.expiresOn = _data["expiresOn"];
            this.vendorId = _data["vendorId"];
            this.vendorSourceRecordId = _data["vendorSourceRecordId"];
            this.vendorOrderNumberId = _data["vendorOrderNumberId"];
            this.pickupTimeslots = _data["pickupTimeslots"] ? PickupTimeslots.fromJS(_data["pickupTimeslots"]) : undefined;
            this.timeStamp = _data["timeStamp"];
        }
    };
    Cart.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Cart();
        result.init(data);
        return result;
    };
    Cart.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["userAlias"] = this.userAlias;
        data["cafeId"] = this.cafeId;
        data["cafeName"] = this.cafeName;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["status"] = this.status;
        if (Array.isArray(this.issues)) {
            data["issues"] = [];
            for (var _b = 0, _c = this.issues; _b < _c.length; _b++) {
                var item = _c[_b];
                data["issues"].push(item.toJSON());
            }
        }
        data["subTotalAmount"] = this.subTotalAmount ? this.subTotalAmount.toJSON() : undefined;
        data["taxAmount"] = this.taxAmount ? this.taxAmount.toJSON() : undefined;
        data["totalAmount"] = this.totalAmount ? this.totalAmount.toJSON() : undefined;
        data["expiresOn"] = this.expiresOn;
        data["vendorId"] = this.vendorId;
        data["vendorSourceRecordId"] = this.vendorSourceRecordId;
        data["vendorOrderNumberId"] = this.vendorOrderNumberId;
        data["pickupTimeslots"] = this.pickupTimeslots ? this.pickupTimeslots.toJSON() : undefined;
        data["timeStamp"] = this.timeStamp;
        return data;
    };
    return Cart;
}());
exports.Cart = Cart;
var CartIssue = /** @class */ (function () {
    function CartIssue(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CartIssue.prototype.init = function (_data) {
        if (_data) {
            this.type = _data["type"];
            this.message = _data["message"];
        }
    };
    CartIssue.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CartIssue();
        result.init(data);
        return result;
    };
    CartIssue.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["message"] = this.message;
        return data;
    };
    return CartIssue;
}());
exports.CartIssue = CartIssue;
var CartIssueType;
(function (CartIssueType) {
    CartIssueType["Unknown"] = "Unknown";
    CartIssueType["CafeClosed"] = "CafeClosed";
    CartIssueType["ItemOrItemsOutOfStock"] = "ItemOrItemsOutOfStock";
})(CartIssueType = exports.CartIssueType || (exports.CartIssueType = {}));
var CartItem = /** @class */ (function () {
    function CartItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CartItem.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.amountWithOptions = _data["amountWithOptions"];
            this.stationId = _data["stationId"];
            this.stationName = _data["stationName"];
            this.customInstruction = _data["customInstruction"];
            this.itemId = _data["itemId"];
            this.menuId = _data["menuId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.category = _data["category"];
            this.imageUrl = _data["imageUrl"];
            this.pricing = _data["pricing"] ? Pricing.fromJS(_data["pricing"]) : undefined;
            this.amount = _data["amount"];
            this.canPurchaseOnline = _data["canPurchaseOnline"];
            this.legacyCafeMenuId = _data["legacyCafeMenuId"];
            this.vendorId = _data["vendorId"];
            this.vendorSourceRecordId = _data["vendorSourceRecordId"];
            this.quantityLimitPerCustomer = _data["quantityLimitPerCustomer"];
            if (Array.isArray(_data["options"])) {
                this.options = [];
                for (var _i = 0, _a = _data["options"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.options.push(MenuItemOptionGroup.fromJS(item));
                }
            }
            this.calories = _data["calories"];
            if (Array.isArray(_data["allergens"])) {
                this.allergens = [];
                for (var _b = 0, _c = _data["allergens"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.allergens.push(Allergen.fromJS(item));
                }
            }
            this.timeStamp = _data["timeStamp"];
        }
    };
    CartItem.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CartItem();
        result.init(data);
        return result;
    };
    CartItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amountWithOptions"] = this.amountWithOptions;
        data["stationId"] = this.stationId;
        data["stationName"] = this.stationName;
        data["customInstruction"] = this.customInstruction;
        data["itemId"] = this.itemId;
        data["menuId"] = this.menuId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["category"] = this.category;
        data["imageUrl"] = this.imageUrl;
        data["pricing"] = this.pricing ? this.pricing.toJSON() : undefined;
        data["amount"] = this.amount;
        data["canPurchaseOnline"] = this.canPurchaseOnline;
        data["legacyCafeMenuId"] = this.legacyCafeMenuId;
        data["vendorId"] = this.vendorId;
        data["vendorSourceRecordId"] = this.vendorSourceRecordId;
        data["quantityLimitPerCustomer"] = this.quantityLimitPerCustomer;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (var _i = 0, _a = this.options; _i < _a.length; _i++) {
                var item = _a[_i];
                data["options"].push(item.toJSON());
            }
        }
        data["calories"] = this.calories;
        if (Array.isArray(this.allergens)) {
            data["allergens"] = [];
            for (var _b = 0, _c = this.allergens; _b < _c.length; _b++) {
                var item = _c[_b];
                data["allergens"].push(item.toJSON());
            }
        }
        data["timeStamp"] = this.timeStamp;
        return data;
    };
    return CartItem;
}());
exports.CartItem = CartItem;
var CartStatus;
(function (CartStatus) {
    CartStatus["Open"] = "Open";
    CartStatus["CheckedOut"] = "CheckedOut";
})(CartStatus = exports.CartStatus || (exports.CartStatus = {}));
var ChoiceGroupType;
(function (ChoiceGroupType) {
    ChoiceGroupType["NONE"] = "NONE";
    ChoiceGroupType["CHOICE_GROUP"] = "CHOICE_GROUP";
})(ChoiceGroupType = exports.ChoiceGroupType || (exports.ChoiceGroupType = {}));
var CommunicationStatusResponse = /** @class */ (function () {
    function CommunicationStatusResponse(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CommunicationStatusResponse.prototype.init = function (_data) {
        if (_data) {
            this.key = _data["key"];
            this.addedRows = _data["addedRows"];
            this.deletedRows = _data["deletedRows"];
            this.isSuccess = _data["isSuccess"];
            this.noActionRows = _data["noActionRows"];
            this.updatedRows = _data["updatedRows"];
        }
    };
    CommunicationStatusResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CommunicationStatusResponse();
        result.init(data);
        return result;
    };
    CommunicationStatusResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["addedRows"] = this.addedRows;
        data["deletedRows"] = this.deletedRows;
        data["isSuccess"] = this.isSuccess;
        data["noActionRows"] = this.noActionRows;
        data["updatedRows"] = this.updatedRows;
        return data;
    };
    return CommunicationStatusResponse;
}());
exports.CommunicationStatusResponse = CommunicationStatusResponse;
var Coordinates = /** @class */ (function () {
    function Coordinates(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Coordinates.prototype.init = function (_data) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    };
    Coordinates.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Coordinates();
        result.init(data);
        return result;
    };
    Coordinates.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    };
    return Coordinates;
}());
exports.Coordinates = Coordinates;
var Country = /** @class */ (function () {
    function Country(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Country.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
        }
    };
    Country.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Country();
        result.init(data);
        return result;
    };
    Country.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    };
    return Country;
}());
exports.Country = Country;
var CurrencyInfo = /** @class */ (function () {
    function CurrencyInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CurrencyInfo.prototype.init = function (_data) {
        if (_data) {
            this.currencyName = _data["currencyName"];
            this.currencySymbol = _data["currencySymbol"];
        }
    };
    CurrencyInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CurrencyInfo();
        result.init(data);
        return result;
    };
    CurrencyInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["currencyName"] = this.currencyName;
        data["currencySymbol"] = this.currencySymbol;
        return data;
    };
    return CurrencyInfo;
}());
exports.CurrencyInfo = CurrencyInfo;
var DraftAllergen = /** @class */ (function () {
    function DraftAllergen(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DraftAllergen.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.optional = _data["optional"];
        }
    };
    DraftAllergen.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DraftAllergen();
        result.init(data);
        return result;
    };
    DraftAllergen.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["optional"] = this.optional;
        return data;
    };
    return DraftAllergen;
}());
exports.DraftAllergen = DraftAllergen;
var DraftCafeStation = /** @class */ (function () {
    function DraftCafeStation(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DraftCafeStation.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["menu"])) {
                this.menu = [];
                for (var _i = 0, _a = _data["menu"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.menu.push(DraftMenu.fromJS(item));
                }
            }
        }
    };
    DraftCafeStation.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DraftCafeStation();
        result.init(data);
        return result;
    };
    DraftCafeStation.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.menu)) {
            data["menu"] = [];
            for (var _i = 0, _a = this.menu; _i < _a.length; _i++) {
                var item = _a[_i];
                data["menu"].push(item.toJSON());
            }
        }
        return data;
    };
    return DraftCafeStation;
}());
exports.DraftCafeStation = DraftCafeStation;
var DraftCafeStationWeeklyMenuSchedule = /** @class */ (function () {
    function DraftCafeStationWeeklyMenuSchedule(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DraftCafeStationWeeklyMenuSchedule.prototype.init = function (_data) {
        if (_data) {
            this.draftCafeStationsSchedule = _data["draftCafeStationsSchedule"] ? DraftCafeStationsSchedule.fromJS(_data["draftCafeStationsSchedule"]) : undefined;
            if (Array.isArray(_data["menuItems"])) {
                this.menuItems = [];
                for (var _i = 0, _a = _data["menuItems"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.menuItems.push(MenuItemDb.fromJS(item));
                }
            }
        }
    };
    DraftCafeStationWeeklyMenuSchedule.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DraftCafeStationWeeklyMenuSchedule();
        result.init(data);
        return result;
    };
    DraftCafeStationWeeklyMenuSchedule.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["draftCafeStationsSchedule"] = this.draftCafeStationsSchedule ? this.draftCafeStationsSchedule.toJSON() : undefined;
        if (Array.isArray(this.menuItems)) {
            data["menuItems"] = [];
            for (var _i = 0, _a = this.menuItems; _i < _a.length; _i++) {
                var item = _a[_i];
                data["menuItems"].push(item.toJSON());
            }
        }
        return data;
    };
    return DraftCafeStationWeeklyMenuSchedule;
}());
exports.DraftCafeStationWeeklyMenuSchedule = DraftCafeStationWeeklyMenuSchedule;
var DraftCafeStationsSchedule = /** @class */ (function () {
    function DraftCafeStationsSchedule(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DraftCafeStationsSchedule.prototype.init = function (_data) {
        if (_data) {
            this.cafeId = _data["cafeId"];
            this.weekStart = _data["weekStart"];
            if (Array.isArray(_data["stations"])) {
                this.stations = [];
                for (var _i = 0, _a = _data["stations"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.stations.push(DraftCafeStation.fromJS(item));
                }
            }
            this.timeStamp = _data["timeStamp"];
        }
    };
    DraftCafeStationsSchedule.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DraftCafeStationsSchedule();
        result.init(data);
        return result;
    };
    DraftCafeStationsSchedule.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["cafeId"] = this.cafeId;
        data["weekStart"] = this.weekStart;
        if (Array.isArray(this.stations)) {
            data["stations"] = [];
            for (var _i = 0, _a = this.stations; _i < _a.length; _i++) {
                var item = _a[_i];
                data["stations"].push(item.toJSON());
            }
        }
        data["timeStamp"] = this.timeStamp;
        return data;
    };
    return DraftCafeStationsSchedule;
}());
exports.DraftCafeStationsSchedule = DraftCafeStationsSchedule;
var DraftMenu = /** @class */ (function () {
    function DraftMenu(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DraftMenu.prototype.init = function (_data) {
        if (_data) {
            this.publishedMenuId = _data["publishedMenuId"];
            if (Array.isArray(_data["weekDays"])) {
                this.weekDays = [];
                for (var _i = 0, _a = _data["weekDays"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.weekDays.push(item);
                }
            }
            this.isPublished = _data["isPublished"];
            this.menuItemId = _data["menuItemId"];
        }
    };
    DraftMenu.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DraftMenu();
        result.init(data);
        return result;
    };
    DraftMenu.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["publishedMenuId"] = this.publishedMenuId;
        if (Array.isArray(this.weekDays)) {
            data["weekDays"] = [];
            for (var _i = 0, _a = this.weekDays; _i < _a.length; _i++) {
                var item = _a[_i];
                data["weekDays"].push(item);
            }
        }
        data["isPublished"] = this.isPublished;
        data["menuItemId"] = this.menuItemId;
        return data;
    };
    return DraftMenu;
}());
exports.DraftMenu = DraftMenu;
var UploadImageResponse = /** @class */ (function () {
    function UploadImageResponse(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UploadImageResponse.prototype.init = function (_data) {
        if (_data) {
            this.imageUrl = _data["imageUrl"];
            this.imagePreviewUrl = _data["imagePreviewUrl"];
        }
    };
    UploadImageResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UploadImageResponse();
        result.init(data);
        return result;
    };
    UploadImageResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["imageUrl"] = this.imageUrl;
        data["imagePreviewUrl"] = this.imagePreviewUrl;
        return data;
    };
    return UploadImageResponse;
}());
exports.UploadImageResponse = UploadImageResponse;
var DistanceUnit;
(function (DistanceUnit) {
    DistanceUnit["Metric"] = "Metric";
    DistanceUnit["Imperial"] = "Imperial";
})(DistanceUnit = exports.DistanceUnit || (exports.DistanceUnit = {}));
var CardPaymentDto = /** @class */ (function () {
    function CardPaymentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CardPaymentDto.prototype.init = function (_data) {
        if (_data) {
            this.accountNumber = _data["accountNumber"];
            this.cvv = _data["cvv"];
            this.expirationMonth = _data["expirationMonth"];
            this.expirationYear = _data["expirationYear"];
        }
    };
    CardPaymentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CardPaymentDto();
        result.init(data);
        return result;
    };
    CardPaymentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["cvv"] = this.cvv;
        data["expirationMonth"] = this.expirationMonth;
        data["expirationYear"] = this.expirationYear;
        return data;
    };
    return CardPaymentDto;
}());
exports.CardPaymentDto = CardPaymentDto;
var CheckPaymentDto = /** @class */ (function () {
    function CheckPaymentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CheckPaymentDto.prototype.init = function (_data) {
        if (_data) {
            this.transactionId = _data["transactionId"];
        }
    };
    CheckPaymentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CheckPaymentDto();
        result.init(data);
        return result;
    };
    CheckPaymentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        return data;
    };
    return CheckPaymentDto;
}());
exports.CheckPaymentDto = CheckPaymentDto;
var MobilePaymentDto = /** @class */ (function () {
    function MobilePaymentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MobilePaymentDto.prototype.init = function (_data) {
        if (_data) {
            this.token = _data["token"];
            this.mobilePaymentType = _data["mobilePaymentType"];
        }
    };
    MobilePaymentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MobilePaymentDto();
        result.init(data);
        return result;
    };
    MobilePaymentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["mobilePaymentType"] = this.mobilePaymentType;
        return data;
    };
    return MobilePaymentDto;
}());
exports.MobilePaymentDto = MobilePaymentDto;
var ImageType;
(function (ImageType) {
    ImageType["Cafe"] = "Cafe";
    ImageType["Station"] = "Station";
    ImageType["MenuItem"] = "MenuItem";
    ImageType["Foodstall"] = "Foodstall";
})(ImageType = exports.ImageType || (exports.ImageType = {}));
var OnlineAvailabilityCapability;
(function (OnlineAvailabilityCapability) {
    OnlineAvailabilityCapability["NeverCapable"] = "NeverCapable";
    OnlineAvailabilityCapability["ComingSoon"] = "ComingSoon";
    OnlineAvailabilityCapability["Capable"] = "Capable";
})(OnlineAvailabilityCapability = exports.OnlineAvailabilityCapability || (exports.OnlineAvailabilityCapability = {}));
var Espresso = /** @class */ (function () {
    function Espresso(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Espresso.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.buildingId = _data["buildingId"];
            this.buildingName = _data["buildingName"];
            this.description = _data["description"];
            this.hours = _data["hours"];
            this.legacyBuildingId = _data["legacyBuildingId"];
            this.locationDetails = _data["locationDetails"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.vendorId = _data["vendorId"];
            this.vendorSourceRecordId = _data["vendorSourceRecordId"];
            this.timeStamp = _data["timeStamp"];
        }
    };
    Espresso.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Espresso();
        result.init(data);
        return result;
    };
    Espresso.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["buildingId"] = this.buildingId;
        data["buildingName"] = this.buildingName;
        data["description"] = this.description;
        data["hours"] = this.hours;
        data["legacyBuildingId"] = this.legacyBuildingId;
        data["locationDetails"] = this.locationDetails;
        data["name"] = this.name;
        data["url"] = this.url;
        data["vendorId"] = this.vendorId;
        data["vendorSourceRecordId"] = this.vendorSourceRecordId;
        data["timeStamp"] = this.timeStamp;
        return data;
    };
    return Espresso;
}());
exports.Espresso = Espresso;
var OrderStatusUpdateEvent = /** @class */ (function () {
    function OrderStatusUpdateEvent(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderStatusUpdateEvent.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.timestamp = _data["timestamp"];
            this.currentStatus = _data["currentStatus"];
            this.previousStatus = _data["previousStatus"];
            this.source = _data["source"];
        }
    };
    OrderStatusUpdateEvent.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderStatusUpdateEvent();
        result.init(data);
        return result;
    };
    OrderStatusUpdateEvent.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["timestamp"] = this.timestamp;
        data["currentStatus"] = this.currentStatus;
        data["previousStatus"] = this.previousStatus;
        data["source"] = this.source;
        return data;
    };
    return OrderStatusUpdateEvent;
}());
exports.OrderStatusUpdateEvent = OrderStatusUpdateEvent;
var SubStatusCode;
(function (SubStatusCode) {
    SubStatusCode["InvalidCartItems"] = "InvalidCartItems";
    SubStatusCode["InvalidSemantics"] = "InvalidSemantics";
    SubStatusCode["StationNotFound"] = "StationNotFound";
    SubStatusCode["UserProfileNotFound"] = "UserProfileNotFound";
    SubStatusCode["CafeNotFound"] = "CafeNotFound";
    SubStatusCode["CustomerRestricted"] = "CustomerRestricted";
    SubStatusCode["CartWrongLocation"] = "CartWrongLocation";
    SubStatusCode["CartNotFound"] = "CartNotFound";
    SubStatusCode["MismatchedSubtotal"] = "MismatchedSubtotal";
    SubStatusCode["InvalidSubtotalFromVendor"] = "InvalidSubtotalFromVendor";
    SubStatusCode["PaymentRejected"] = "PaymentRejected";
    SubStatusCode["AddedInvalidCartItemToCart"] = "AddedInvalidCartItemToCart";
    SubStatusCode["PaymentServiceCallFailed"] = "PaymentServiceCallFailed";
    SubStatusCode["OrderNotFound"] = "OrderNotFound";
    SubStatusCode["OrderNotReadyForPickup"] = "OrderNotReadyForPickup";
    SubStatusCode["OrderNotCannotFulfill"] = "OrderNotCannotFulfill";
    SubStatusCode["WrongVendorId"] = "WrongVendorId";
    SubStatusCode["FailedToPlaceOrderInTheVendorSystem"] = "FailedToPlaceOrderInTheVendorSystem";
    SubStatusCode["MissingOrderNumber"] = "MissingOrderNumber";
    SubStatusCode["InvalidImageFormat"] = "InvalidImageFormat";
})(SubStatusCode = exports.SubStatusCode || (exports.SubStatusCode = {}));
var GeographyPointLocation = /** @class */ (function () {
    function GeographyPointLocation(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.coordinates = [];
        }
    }
    GeographyPointLocation.prototype.init = function (_data) {
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["coordinates"])) {
                this.coordinates = [];
                for (var _i = 0, _a = _data["coordinates"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.coordinates.push(item);
                }
            }
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    };
    GeographyPointLocation.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GeographyPointLocation();
        result.init(data);
        return result;
    };
    GeographyPointLocation.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.coordinates)) {
            data["coordinates"] = [];
            for (var _i = 0, _a = this.coordinates; _i < _a.length; _i++) {
                var item = _a[_i];
                data["coordinates"].push(item);
            }
        }
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    };
    return GeographyPointLocation;
}());
exports.GeographyPointLocation = GeographyPointLocation;
var HoursOfOperation = /** @class */ (function () {
    function HoursOfOperation(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HoursOfOperation.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.dayOfWeek = _data["dayOfWeek"];
            if (Array.isArray(_data["hours"])) {
                this.hours = [];
                for (var _i = 0, _a = _data["hours"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.hours.push(item);
                }
            }
            this.timeStamp = _data["timeStamp"];
        }
    };
    HoursOfOperation.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HoursOfOperation();
        result.init(data);
        return result;
    };
    HoursOfOperation.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dayOfWeek"] = this.dayOfWeek;
        if (Array.isArray(this.hours)) {
            data["hours"] = [];
            for (var _i = 0, _a = this.hours; _i < _a.length; _i++) {
                var item = _a[_i];
                data["hours"].push(item);
            }
        }
        data["timeStamp"] = this.timeStamp;
        return data;
    };
    return HoursOfOperation;
}());
exports.HoursOfOperation = HoursOfOperation;
var ItemType;
(function (ItemType) {
    ItemType["NONE"] = "NONE";
    ItemType["MODIFIER"] = "MODIFIER";
    ItemType["ITEM"] = "ITEM";
})(ItemType = exports.ItemType || (exports.ItemType = {}));
var MarketLocation = /** @class */ (function () {
    function MarketLocation(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MarketLocation.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.buildingId = _data["buildingId"];
            this.buildingName = _data["buildingName"];
            this.hours = _data["hours"];
            this.legacyBuildingId = _data["legacyBuildingId"];
            this.location = _data["location"];
            this.name = _data["name"];
            this.region = _data["region"] ? Region.fromJS(_data["region"]) : undefined;
            this.vendorId = _data["vendorId"];
            this.vendorSourceRecordId = _data["vendorSourceRecordId"];
            this.timeStamp = _data["timeStamp"];
        }
    };
    MarketLocation.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MarketLocation();
        result.init(data);
        return result;
    };
    MarketLocation.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["buildingId"] = this.buildingId;
        data["buildingName"] = this.buildingName;
        data["hours"] = this.hours;
        data["legacyBuildingId"] = this.legacyBuildingId;
        data["location"] = this.location;
        data["name"] = this.name;
        data["region"] = this.region ? this.region.toJSON() : undefined;
        data["vendorId"] = this.vendorId;
        data["vendorSourceRecordId"] = this.vendorSourceRecordId;
        data["timeStamp"] = this.timeStamp;
        return data;
    };
    return MarketLocation;
}());
exports.MarketLocation = MarketLocation;
var MealCardBalanceInfo = /** @class */ (function () {
    function MealCardBalanceInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MealCardBalanceInfo.prototype.init = function (_data) {
        if (_data) {
            this.balance = _data["balance"];
        }
    };
    MealCardBalanceInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MealCardBalanceInfo();
        result.init(data);
        return result;
    };
    MealCardBalanceInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["balance"] = this.balance;
        return data;
    };
    return MealCardBalanceInfo;
}());
exports.MealCardBalanceInfo = MealCardBalanceInfo;
var MealPeriod = /** @class */ (function () {
    function MealPeriod(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MealPeriod.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.startsOn = _data["startsOn"];
            this.endsOn = _data["endsOn"];
            this.customPeriod = _data["customPeriod"];
            this.hoursOfOperation = _data["hoursOfOperation"];
            this.timeStamp = _data["timeStamp"];
        }
    };
    MealPeriod.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MealPeriod();
        result.init(data);
        return result;
    };
    MealPeriod.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["startsOn"] = this.startsOn;
        data["endsOn"] = this.endsOn;
        data["customPeriod"] = this.customPeriod;
        data["hoursOfOperation"] = this.hoursOfOperation;
        data["timeStamp"] = this.timeStamp;
        return data;
    };
    return MealPeriod;
}());
exports.MealPeriod = MealPeriod;
var MealPeriodType;
(function (MealPeriodType) {
    MealPeriodType["Default"] = "Default";
    MealPeriodType["Breakfast"] = "Breakfast";
    MealPeriodType["Lunch"] = "Lunch";
    MealPeriodType["Dinner"] = "Dinner";
    MealPeriodType["HappyHour"] = "HappyHour";
    MealPeriodType["AllDay"] = "AllDay";
})(MealPeriodType = exports.MealPeriodType || (exports.MealPeriodType = {}));
var Menu = /** @class */ (function () {
    function Menu(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Menu.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["menuItemIds"])) {
                this.menuItemIds = [];
                for (var _i = 0, _a = _data["menuItemIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.menuItemIds.push(item);
                }
            }
            this.canPurchaseItemsOnline = _data["canPurchaseItemsOnline"];
            this.vendorId = _data["vendorId"];
            this.vendorSourceRecordId = _data["vendorSourceRecordId"];
            this.timeStamp = _data["timeStamp"];
        }
    };
    Menu.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Menu();
        result.init(data);
        return result;
    };
    Menu.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.menuItemIds)) {
            data["menuItemIds"] = [];
            for (var _i = 0, _a = this.menuItemIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["menuItemIds"].push(item);
            }
        }
        data["canPurchaseItemsOnline"] = this.canPurchaseItemsOnline;
        data["vendorId"] = this.vendorId;
        data["vendorSourceRecordId"] = this.vendorSourceRecordId;
        data["timeStamp"] = this.timeStamp;
        return data;
    };
    return Menu;
}());
exports.Menu = Menu;
var MenuItemDb = /** @class */ (function () {
    function MenuItemDb(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MenuItemDb.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.stationId = _data["stationId"];
            this.timeToLiveInSeconds = _data["timeToLiveInSeconds"];
            this.itemId = _data["itemId"];
            this.menuId = _data["menuId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.category = _data["category"];
            this.imageUrl = _data["imageUrl"];
            this.pricing = _data["pricing"] ? Pricing.fromJS(_data["pricing"]) : undefined;
            this.amount = _data["amount"];
            this.canPurchaseOnline = _data["canPurchaseOnline"];
            this.legacyCafeMenuId = _data["legacyCafeMenuId"];
            this.vendorId = _data["vendorId"];
            this.vendorSourceRecordId = _data["vendorSourceRecordId"];
            this.quantityLimitPerCustomer = _data["quantityLimitPerCustomer"];
            if (Array.isArray(_data["options"])) {
                this.options = [];
                for (var _i = 0, _a = _data["options"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.options.push(MenuItemOptionGroup.fromJS(item));
                }
            }
            this.calories = _data["calories"];
            if (Array.isArray(_data["allergens"])) {
                this.allergens = [];
                for (var _b = 0, _c = _data["allergens"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.allergens.push(Allergen.fromJS(item));
                }
            }
            this.timeStamp = _data["timeStamp"];
        }
    };
    MenuItemDb.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MenuItemDb();
        result.init(data);
        return result;
    };
    MenuItemDb.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stationId"] = this.stationId;
        data["timeToLiveInSeconds"] = this.timeToLiveInSeconds;
        data["itemId"] = this.itemId;
        data["menuId"] = this.menuId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["category"] = this.category;
        data["imageUrl"] = this.imageUrl;
        data["pricing"] = this.pricing ? this.pricing.toJSON() : undefined;
        data["amount"] = this.amount;
        data["canPurchaseOnline"] = this.canPurchaseOnline;
        data["legacyCafeMenuId"] = this.legacyCafeMenuId;
        data["vendorId"] = this.vendorId;
        data["vendorSourceRecordId"] = this.vendorSourceRecordId;
        data["quantityLimitPerCustomer"] = this.quantityLimitPerCustomer;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (var _i = 0, _a = this.options; _i < _a.length; _i++) {
                var item = _a[_i];
                data["options"].push(item.toJSON());
            }
        }
        data["calories"] = this.calories;
        if (Array.isArray(this.allergens)) {
            data["allergens"] = [];
            for (var _b = 0, _c = this.allergens; _b < _c.length; _b++) {
                var item = _c[_b];
                data["allergens"].push(item.toJSON());
            }
        }
        data["timeStamp"] = this.timeStamp;
        return data;
    };
    return MenuItemDb;
}());
exports.MenuItemDb = MenuItemDb;
var MenuItemOption = /** @class */ (function () {
    function MenuItemOption(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MenuItemOption.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.price = _data["price"] ? Pricing.fromJS(_data["price"]) : undefined;
            this.amount = _data["amount"];
            this.itemType = _data["itemType"];
            this.itemId = _data["itemId"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["optionGroup"])) {
                this.optionGroup = [];
                for (var _i = 0, _a = _data["optionGroup"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.optionGroup.push(MenuItemOptionGroup.fromJS(item));
                }
            }
            this.isSelected = _data["isSelected"];
            this.timeStamp = _data["timeStamp"];
        }
    };
    MenuItemOption.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MenuItemOption();
        result.init(data);
        return result;
    };
    MenuItemOption.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["price"] = this.price ? this.price.toJSON() : undefined;
        data["amount"] = this.amount;
        data["itemType"] = this.itemType;
        data["itemId"] = this.itemId;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.optionGroup)) {
            data["optionGroup"] = [];
            for (var _i = 0, _a = this.optionGroup; _i < _a.length; _i++) {
                var item = _a[_i];
                data["optionGroup"].push(item.toJSON());
            }
        }
        data["isSelected"] = this.isSelected;
        data["timeStamp"] = this.timeStamp;
        return data;
    };
    return MenuItemOption;
}());
exports.MenuItemOption = MenuItemOption;
var MenuItemOptionGroup = /** @class */ (function () {
    function MenuItemOptionGroup(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MenuItemOptionGroup.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.groupType = _data["groupType"];
            this.minimum = _data["minimum"];
            this.maximum = _data["maximum"];
            this.isSingleSelect = _data["isSingleSelect"];
            this.sequenceNo = _data["sequenceNo"];
            if (Array.isArray(_data["options"])) {
                this.options = [];
                for (var _i = 0, _a = _data["options"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.options.push(MenuItemOption.fromJS(item));
                }
            }
            this.vendorSourceRecordId = _data["vendorSourceRecordId"];
            this.vendorId = _data["vendorId"];
            this.timeStamp = _data["timeStamp"];
        }
    };
    MenuItemOptionGroup.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MenuItemOptionGroup();
        result.init(data);
        return result;
    };
    MenuItemOptionGroup.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["groupType"] = this.groupType;
        data["minimum"] = this.minimum;
        data["maximum"] = this.maximum;
        data["isSingleSelect"] = this.isSingleSelect;
        data["sequenceNo"] = this.sequenceNo;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (var _i = 0, _a = this.options; _i < _a.length; _i++) {
                var item = _a[_i];
                data["options"].push(item.toJSON());
            }
        }
        data["vendorSourceRecordId"] = this.vendorSourceRecordId;
        data["vendorId"] = this.vendorId;
        data["timeStamp"] = this.timeStamp;
        return data;
    };
    return MenuItemOptionGroup;
}());
exports.MenuItemOptionGroup = MenuItemOptionGroup;
var MobilePaymentType;
(function (MobilePaymentType) {
    MobilePaymentType["ApplePay"] = "ApplePay";
    MobilePaymentType["GooglePay"] = "GooglePay";
})(MobilePaymentType = exports.MobilePaymentType || (exports.MobilePaymentType = {}));
var CollectionResponseOfBuilding = /** @class */ (function () {
    function CollectionResponseOfBuilding(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CollectionResponseOfBuilding.prototype.init = function (_data) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(Building.fromJS(item));
                }
            }
            if (_data["metadata"]) {
                this.metadata = {};
                for (var key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        this.metadata[key] = _data["metadata"][key];
                }
            }
        }
    };
    CollectionResponseOfBuilding.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CollectionResponseOfBuilding();
        result.init(data);
        return result;
    };
    CollectionResponseOfBuilding.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        if (this.metadata) {
            data["metadata"] = {};
            for (var key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    data["metadata"][key] = this.metadata[key];
            }
        }
        return data;
    };
    return CollectionResponseOfBuilding;
}());
exports.CollectionResponseOfBuilding = CollectionResponseOfBuilding;
var CollectionResponseOfOrder = /** @class */ (function () {
    function CollectionResponseOfOrder(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CollectionResponseOfOrder.prototype.init = function (_data) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(Order.fromJS(item));
                }
            }
            if (_data["metadata"]) {
                this.metadata = {};
                for (var key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        this.metadata[key] = _data["metadata"][key];
                }
            }
        }
    };
    CollectionResponseOfOrder.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CollectionResponseOfOrder();
        result.init(data);
        return result;
    };
    CollectionResponseOfOrder.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        if (this.metadata) {
            data["metadata"] = {};
            for (var key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    data["metadata"][key] = this.metadata[key];
            }
        }
        return data;
    };
    return CollectionResponseOfOrder;
}());
exports.CollectionResponseOfOrder = CollectionResponseOfOrder;
var CollectionResponseOfCafeListItemViewModel = /** @class */ (function () {
    function CollectionResponseOfCafeListItemViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CollectionResponseOfCafeListItemViewModel.prototype.init = function (_data) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(CafeListItemViewModel.fromJS(item));
                }
            }
            if (_data["metadata"]) {
                this.metadata = {};
                for (var key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        this.metadata[key] = _data["metadata"][key];
                }
            }
        }
    };
    CollectionResponseOfCafeListItemViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CollectionResponseOfCafeListItemViewModel();
        result.init(data);
        return result;
    };
    CollectionResponseOfCafeListItemViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        if (this.metadata) {
            data["metadata"] = {};
            for (var key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    data["metadata"][key] = this.metadata[key];
            }
        }
        return data;
    };
    return CollectionResponseOfCafeListItemViewModel;
}());
exports.CollectionResponseOfCafeListItemViewModel = CollectionResponseOfCafeListItemViewModel;
var CollectionResponseOfStationViewModel = /** @class */ (function () {
    function CollectionResponseOfStationViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CollectionResponseOfStationViewModel.prototype.init = function (_data) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(StationViewModel.fromJS(item));
                }
            }
            if (_data["metadata"]) {
                this.metadata = {};
                for (var key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        this.metadata[key] = _data["metadata"][key];
                }
            }
        }
    };
    CollectionResponseOfStationViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CollectionResponseOfStationViewModel();
        result.init(data);
        return result;
    };
    CollectionResponseOfStationViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        if (this.metadata) {
            data["metadata"] = {};
            for (var key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    data["metadata"][key] = this.metadata[key];
            }
        }
        return data;
    };
    return CollectionResponseOfStationViewModel;
}());
exports.CollectionResponseOfStationViewModel = CollectionResponseOfStationViewModel;
var CollectionResponseOfOnlineMenu = /** @class */ (function () {
    function CollectionResponseOfOnlineMenu(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CollectionResponseOfOnlineMenu.prototype.init = function (_data) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(OnlineMenu.fromJS(item));
                }
            }
            if (_data["metadata"]) {
                this.metadata = {};
                for (var key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        this.metadata[key] = _data["metadata"][key];
                }
            }
        }
    };
    CollectionResponseOfOnlineMenu.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CollectionResponseOfOnlineMenu();
        result.init(data);
        return result;
    };
    CollectionResponseOfOnlineMenu.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        if (this.metadata) {
            data["metadata"] = {};
            for (var key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    data["metadata"][key] = this.metadata[key];
            }
        }
        return data;
    };
    return CollectionResponseOfOnlineMenu;
}());
exports.CollectionResponseOfOnlineMenu = CollectionResponseOfOnlineMenu;
var Order = /** @class */ (function () {
    function Order(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.payment = new Payment();
            this.items = [];
            this.subTotalAmount = new Pricing();
            this.taxAmount = new Pricing();
            this.totalAmount = new Pricing();
            this.orderStatusHistory = [];
        }
    }
    Order.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.payment = _data["payment"] ? Payment.fromJS(_data["payment"]) : new Payment();
            this.cafeId = _data["cafeId"];
            this.cafeName = _data["cafeName"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(OrderItem.fromJS(item));
                }
            }
            this.subTotalAmount = _data["subTotalAmount"] ? Pricing.fromJS(_data["subTotalAmount"]) : new Pricing();
            this.taxAmount = _data["taxAmount"] ? Pricing.fromJS(_data["taxAmount"]) : new Pricing();
            this.totalAmount = _data["totalAmount"] ? Pricing.fromJS(_data["totalAmount"]) : new Pricing();
            this.vendorId = _data["vendorId"];
            this.vendorSourceRecordId = _data["vendorSourceRecordId"];
            this.orderNumber = _data["orderNumber"];
            this.status = _data["status"];
            if (Array.isArray(_data["orderStatusHistory"])) {
                this.orderStatusHistory = [];
                for (var _b = 0, _c = _data["orderStatusHistory"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.orderStatusHistory.push(OrderStatusUpdateEvent.fromJS(item));
                }
            }
            this.timeStamp = _data["timeStamp"];
        }
    };
    Order.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Order();
        result.init(data);
        return result;
    };
    Order.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["payment"] = this.payment ? this.payment.toJSON() : undefined;
        data["cafeId"] = this.cafeId;
        data["cafeName"] = this.cafeName;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        data["subTotalAmount"] = this.subTotalAmount ? this.subTotalAmount.toJSON() : undefined;
        data["taxAmount"] = this.taxAmount ? this.taxAmount.toJSON() : undefined;
        data["totalAmount"] = this.totalAmount ? this.totalAmount.toJSON() : undefined;
        data["vendorId"] = this.vendorId;
        data["vendorSourceRecordId"] = this.vendorSourceRecordId;
        data["orderNumber"] = this.orderNumber;
        data["status"] = this.status;
        if (Array.isArray(this.orderStatusHistory)) {
            data["orderStatusHistory"] = [];
            for (var _b = 0, _c = this.orderStatusHistory; _b < _c.length; _b++) {
                var item = _c[_b];
                data["orderStatusHistory"].push(item.toJSON());
            }
        }
        data["timeStamp"] = this.timeStamp;
        return data;
    };
    return Order;
}());
exports.Order = Order;
var OrderItem = /** @class */ (function () {
    function OrderItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderItem.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.amountWithOptions = _data["amountWithOptions"];
            this.stationId = _data["stationId"];
            this.stationName = _data["stationName"];
            this.customInstruction = _data["customInstruction"];
            this.itemId = _data["itemId"];
            this.menuId = _data["menuId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.category = _data["category"];
            this.imageUrl = _data["imageUrl"];
            this.pricing = _data["pricing"] ? Pricing.fromJS(_data["pricing"]) : undefined;
            this.amount = _data["amount"];
            this.canPurchaseOnline = _data["canPurchaseOnline"];
            this.legacyCafeMenuId = _data["legacyCafeMenuId"];
            this.vendorId = _data["vendorId"];
            this.vendorSourceRecordId = _data["vendorSourceRecordId"];
            this.quantityLimitPerCustomer = _data["quantityLimitPerCustomer"];
            if (Array.isArray(_data["options"])) {
                this.options = [];
                for (var _i = 0, _a = _data["options"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.options.push(MenuItemOptionGroup.fromJS(item));
                }
            }
            this.calories = _data["calories"];
            if (Array.isArray(_data["allergens"])) {
                this.allergens = [];
                for (var _b = 0, _c = _data["allergens"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.allergens.push(Allergen.fromJS(item));
                }
            }
            this.timeStamp = _data["timeStamp"];
        }
    };
    OrderItem.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderItem();
        result.init(data);
        return result;
    };
    OrderItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amountWithOptions"] = this.amountWithOptions;
        data["stationId"] = this.stationId;
        data["stationName"] = this.stationName;
        data["customInstruction"] = this.customInstruction;
        data["itemId"] = this.itemId;
        data["menuId"] = this.menuId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["category"] = this.category;
        data["imageUrl"] = this.imageUrl;
        data["pricing"] = this.pricing ? this.pricing.toJSON() : undefined;
        data["amount"] = this.amount;
        data["canPurchaseOnline"] = this.canPurchaseOnline;
        data["legacyCafeMenuId"] = this.legacyCafeMenuId;
        data["vendorId"] = this.vendorId;
        data["vendorSourceRecordId"] = this.vendorSourceRecordId;
        data["quantityLimitPerCustomer"] = this.quantityLimitPerCustomer;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (var _i = 0, _a = this.options; _i < _a.length; _i++) {
                var item = _a[_i];
                data["options"].push(item.toJSON());
            }
        }
        data["calories"] = this.calories;
        if (Array.isArray(this.allergens)) {
            data["allergens"] = [];
            for (var _b = 0, _c = this.allergens; _b < _c.length; _b++) {
                var item = _c[_b];
                data["allergens"].push(item.toJSON());
            }
        }
        data["timeStamp"] = this.timeStamp;
        return data;
    };
    return OrderItem;
}());
exports.OrderItem = OrderItem;
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["Null"] = "Null";
    OrderStatus["PaymentMade"] = "PaymentMade";
    OrderStatus["PaymentAttached"] = "PaymentAttached";
    OrderStatus["SubmittedToVendor"] = "SubmittedToVendor";
    OrderStatus["Canceled"] = "Canceled";
    OrderStatus["CannotFulfill"] = "CannotFulfill";
    OrderStatus["CannotFulfillAcknowledged"] = "CannotFulfillAcknowledged";
    OrderStatus["BeingPrepared"] = "BeingPrepared";
    OrderStatus["ReadyForPickup"] = "ReadyForPickup";
    OrderStatus["PickupCompleted"] = "PickupCompleted";
    OrderStatus["CompletedBySystem"] = "CompletedBySystem";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
var Payment = /** @class */ (function () {
    function Payment(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Payment.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.timeStamp = _data["timeStamp"];
        }
    };
    Payment.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Payment();
        result.init(data);
        return result;
    };
    Payment.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["timeStamp"] = this.timeStamp;
        return data;
    };
    return Payment;
}());
exports.Payment = Payment;
var PaymentConfiguration = /** @class */ (function () {
    function PaymentConfiguration(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaymentConfiguration.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["supportedMethods"])) {
                this.supportedMethods = [];
                for (var _i = 0, _a = _data["supportedMethods"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.supportedMethods.push(SupportedMethod.fromJS(item));
                }
            }
            this.googlePayMerchantIdentifier = _data["googlePayMerchantIdentifier"];
            this.applePayMerchantIdentifier = _data["applePayMerchantIdentifier"];
            this.genericApplePayMerchantIdentifier = _data["genericApplePayMerchantIdentifier"];
            if (Array.isArray(_data["supportedNetworks"])) {
                this.supportedNetworks = [];
                for (var _b = 0, _c = _data["supportedNetworks"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.supportedNetworks.push(SupportedNetwork.fromJS(item));
                }
            }
            if (Array.isArray(_data["allowedPaymentMethods"])) {
                this.allowedPaymentMethods = [];
                for (var _d = 0, _e = _data["allowedPaymentMethods"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.allowedPaymentMethods.push(PaymentMethod.fromJS(item));
                }
            }
            this.countryCode = _data["countryCode"];
            this.currencyCode = _data["currencyCode"];
            this.tokenizationType = _data["tokenizationType"];
            this.gateway = _data["gateway"];
            this.gatewayMerchantId = _data["gatewayMerchantId"];
            this.protocolVersion = _data["protocolVersion"];
            this.publicKey = _data["publicKey"];
            this.timeStamp = _data["timeStamp"];
        }
    };
    PaymentConfiguration.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaymentConfiguration();
        result.init(data);
        return result;
    };
    PaymentConfiguration.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.supportedMethods)) {
            data["supportedMethods"] = [];
            for (var _i = 0, _a = this.supportedMethods; _i < _a.length; _i++) {
                var item = _a[_i];
                data["supportedMethods"].push(item.toJSON());
            }
        }
        data["googlePayMerchantIdentifier"] = this.googlePayMerchantIdentifier;
        data["applePayMerchantIdentifier"] = this.applePayMerchantIdentifier;
        data["genericApplePayMerchantIdentifier"] = this.genericApplePayMerchantIdentifier;
        if (Array.isArray(this.supportedNetworks)) {
            data["supportedNetworks"] = [];
            for (var _b = 0, _c = this.supportedNetworks; _b < _c.length; _b++) {
                var item = _c[_b];
                data["supportedNetworks"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.allowedPaymentMethods)) {
            data["allowedPaymentMethods"] = [];
            for (var _d = 0, _e = this.allowedPaymentMethods; _d < _e.length; _d++) {
                var item = _e[_d];
                data["allowedPaymentMethods"].push(item.toJSON());
            }
        }
        data["countryCode"] = this.countryCode;
        data["currencyCode"] = this.currencyCode;
        data["tokenizationType"] = this.tokenizationType;
        data["gateway"] = this.gateway;
        data["gatewayMerchantId"] = this.gatewayMerchantId;
        data["protocolVersion"] = this.protocolVersion;
        data["publicKey"] = this.publicKey;
        data["timeStamp"] = this.timeStamp;
        return data;
    };
    return PaymentConfiguration;
}());
exports.PaymentConfiguration = PaymentConfiguration;
var PickupTimeslots = /** @class */ (function () {
    function PickupTimeslots(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PickupTimeslots.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.interval = _data["interval"];
            if (Array.isArray(_data["availableTimeslots"])) {
                this.availableTimeslots = [];
                for (var _i = 0, _a = _data["availableTimeslots"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.availableTimeslots.push(Timeslot.fromJS(item));
                }
            }
            this.selectedTimeslot = _data["selectedTimeslot"] ? Timeslot.fromJS(_data["selectedTimeslot"]) : undefined;
        }
    };
    PickupTimeslots.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PickupTimeslots();
        result.init(data);
        return result;
    };
    PickupTimeslots.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["interval"] = this.interval;
        if (Array.isArray(this.availableTimeslots)) {
            data["availableTimeslots"] = [];
            for (var _i = 0, _a = this.availableTimeslots; _i < _a.length; _i++) {
                var item = _a[_i];
                data["availableTimeslots"].push(item.toJSON());
            }
        }
        data["selectedTimeslot"] = this.selectedTimeslot ? this.selectedTimeslot.toJSON() : undefined;
        return data;
    };
    return PickupTimeslots;
}());
exports.PickupTimeslots = PickupTimeslots;
var PingResponse = /** @class */ (function () {
    function PingResponse(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PingResponse.prototype.init = function (_data) {
        if (_data) {
            this.environmment = _data["environmment"];
            this.timestamp = _data["timestamp"];
            if (Array.isArray(_data["failedDependencies"])) {
                this.failedDependencies = [];
                for (var _i = 0, _a = _data["failedDependencies"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.failedDependencies.push(item);
                }
            }
        }
    };
    PingResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PingResponse();
        result.init(data);
        return result;
    };
    PingResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["environmment"] = this.environmment;
        data["timestamp"] = this.timestamp;
        if (Array.isArray(this.failedDependencies)) {
            data["failedDependencies"] = [];
            for (var _i = 0, _a = this.failedDependencies; _i < _a.length; _i++) {
                var item = _a[_i];
                data["failedDependencies"].push(item);
            }
        }
        return data;
    };
    return PingResponse;
}());
exports.PingResponse = PingResponse;
var Pricing = /** @class */ (function () {
    function Pricing(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Pricing.prototype.init = function (_data) {
        if (_data) {
            this.currencyUnit = _data["currencyUnit"];
            this.amount = _data["amount"];
        }
    };
    Pricing.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Pricing();
        result.init(data);
        return result;
    };
    Pricing.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["currencyUnit"] = this.currencyUnit;
        data["amount"] = this.amount;
        return data;
    };
    return Pricing;
}());
exports.Pricing = Pricing;
var Region = /** @class */ (function () {
    function Region(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Region.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.regionId = _data["regionId"];
            if (Array.isArray(_data["cafes"])) {
                this.cafes = [];
                for (var _i = 0, _a = _data["cafes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.cafes.push(Cafe.fromJS(item));
                }
            }
            if (Array.isArray(_data["cafeProfiles"])) {
                this.cafeProfiles = [];
                for (var _b = 0, _c = _data["cafeProfiles"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.cafeProfiles.push(CafeProfile.fromJS(item));
                }
            }
            if (Array.isArray(_data["countries"])) {
                this.countries = [];
                for (var _d = 0, _e = _data["countries"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.countries.push(Country.fromJS(item));
                }
            }
            this.timeStamp = _data["timeStamp"];
        }
    };
    Region.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Region();
        result.init(data);
        return result;
    };
    Region.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["regionId"] = this.regionId;
        if (Array.isArray(this.cafes)) {
            data["cafes"] = [];
            for (var _i = 0, _a = this.cafes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["cafes"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.cafeProfiles)) {
            data["cafeProfiles"] = [];
            for (var _b = 0, _c = this.cafeProfiles; _b < _c.length; _b++) {
                var item = _c[_b];
                data["cafeProfiles"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (var _d = 0, _e = this.countries; _d < _e.length; _d++) {
                var item = _e[_d];
                data["countries"].push(item.toJSON());
            }
        }
        data["timeStamp"] = this.timeStamp;
        return data;
    };
    return Region;
}());
exports.Region = Region;
var RegionCafeListItem = /** @class */ (function () {
    function RegionCafeListItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RegionCafeListItem.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isOnlyForBetaUsers = _data["isOnlyForBetaUsers"];
            this.isDecommissioned = _data["isDecommissioned"];
            this.timeStamp = _data["timeStamp"];
        }
    };
    RegionCafeListItem.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RegionCafeListItem();
        result.init(data);
        return result;
    };
    RegionCafeListItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isOnlyForBetaUsers"] = this.isOnlyForBetaUsers;
        data["isDecommissioned"] = this.isDecommissioned;
        data["timeStamp"] = this.timeStamp;
        return data;
    };
    return RegionCafeListItem;
}());
exports.RegionCafeListItem = RegionCafeListItem;
var Schedule = /** @class */ (function () {
    function Schedule(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Schedule.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.dayOfWeek = _data["dayOfWeek"];
            this.endsOn = _data["endsOn"];
            this.legacyStationId = _data["legacyStationId"];
            this.mealPeriod = _data["mealPeriod"];
            this.menuId = _data["menuId"];
            this.name = _data["name"];
            this.stationId = _data["stationId"];
            this.startsOn = _data["startsOn"];
            this.canPurchaseOnline = _data["canPurchaseOnline"];
            this.timeStamp = _data["timeStamp"];
        }
    };
    Schedule.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Schedule();
        result.init(data);
        return result;
    };
    Schedule.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dayOfWeek"] = this.dayOfWeek;
        data["endsOn"] = this.endsOn;
        data["legacyStationId"] = this.legacyStationId;
        data["mealPeriod"] = this.mealPeriod;
        data["menuId"] = this.menuId;
        data["name"] = this.name;
        data["stationId"] = this.stationId;
        data["startsOn"] = this.startsOn;
        data["canPurchaseOnline"] = this.canPurchaseOnline;
        data["timeStamp"] = this.timeStamp;
        return data;
    };
    return Schedule;
}());
exports.Schedule = Schedule;
var Station = /** @class */ (function () {
    function Station(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.menus = [];
        }
    }
    Station.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.legacyStationId = _data["legacyStationId"];
            if (Array.isArray(_data["menus"])) {
                this.menus = [];
                for (var _i = 0, _a = _data["menus"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.menus.push(Menu.fromJS(item));
                }
            }
            this.name = _data["name"];
            if (Array.isArray(_data["schedules"])) {
                this.schedules = [];
                for (var _b = 0, _c = _data["schedules"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.schedules.push(Schedule.fromJS(item));
                }
            }
            this.vendorSourceCafeId = _data["vendorSourceCafeId"];
            this.imageUrl = _data["imageUrl"];
            this.isOnlyForBetaUsers = _data["isOnlyForBetaUsers"];
            this.canPurchaseItemsOnline = _data["canPurchaseItemsOnline"];
            this.timeStamp = _data["timeStamp"];
        }
    };
    Station.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Station();
        result.init(data);
        return result;
    };
    Station.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["legacyStationId"] = this.legacyStationId;
        if (Array.isArray(this.menus)) {
            data["menus"] = [];
            for (var _i = 0, _a = this.menus; _i < _a.length; _i++) {
                var item = _a[_i];
                data["menus"].push(item.toJSON());
            }
        }
        data["name"] = this.name;
        if (Array.isArray(this.schedules)) {
            data["schedules"] = [];
            for (var _b = 0, _c = this.schedules; _b < _c.length; _b++) {
                var item = _c[_b];
                data["schedules"].push(item.toJSON());
            }
        }
        data["vendorSourceCafeId"] = this.vendorSourceCafeId;
        data["imageUrl"] = this.imageUrl;
        data["isOnlyForBetaUsers"] = this.isOnlyForBetaUsers;
        data["canPurchaseItemsOnline"] = this.canPurchaseItemsOnline;
        data["timeStamp"] = this.timeStamp;
        return data;
    };
    return Station;
}());
exports.Station = Station;
var Timeslot = /** @class */ (function () {
    function Timeslot(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Timeslot.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.start = _data["start"];
            this.end = _data["end"];
        }
    };
    Timeslot.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Timeslot();
        result.init(data);
        return result;
    };
    Timeslot.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["start"] = this.start;
        data["end"] = this.end;
        return data;
    };
    return Timeslot;
}());
exports.Timeslot = Timeslot;
var Timezone = /** @class */ (function () {
    function Timezone(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Timezone.prototype.init = function (_data) {
        if (_data) {
            this.code = _data["code"];
            this.daylight = _data["daylight"];
            this.generic = _data["generic"];
            this.isO6391LanguageCode = _data["isO6391LanguageCode"];
            this.standard = _data["standard"];
        }
    };
    Timezone.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Timezone();
        result.init(data);
        return result;
    };
    Timezone.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["daylight"] = this.daylight;
        data["generic"] = this.generic;
        data["isO6391LanguageCode"] = this.isO6391LanguageCode;
        data["standard"] = this.standard;
        return data;
    };
    return Timezone;
}());
exports.Timezone = Timezone;
var UserFavorite = /** @class */ (function () {
    function UserFavorite(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserFavorite.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.timeStamp = _data["timeStamp"];
        }
    };
    UserFavorite.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserFavorite();
        result.init(data);
        return result;
    };
    UserFavorite.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["timeStamp"] = this.timeStamp;
        return data;
    };
    return UserFavorite;
}());
exports.UserFavorite = UserFavorite;
var CafeListItemViewModel = /** @class */ (function () {
    function CafeListItemViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.location = new GeographyPointLocation();
            this.coordinates = new Coordinates();
        }
    }
    CafeListItemViewModel.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.timestamp = _data["timestamp"];
            this.name = _data["name"];
            this.buildingId = _data["buildingId"];
            this.buildingName = _data["buildingName"];
            this.location = _data["location"] ? GeographyPointLocation.fromJS(_data["location"]) : new GeographyPointLocation();
            this.coordinates = _data["coordinates"] ? Coordinates.fromJS(_data["coordinates"]) : new Coordinates();
            this.serviceHours = _data["serviceHours"];
            this.cafeId = _data["cafeId"];
            this.legacyBuildingId = _data["legacyBuildingId"];
            this.countryCode = _data["countryCode"];
            this.onlineAvailabilityCapability = _data["onlineAvailabilityCapability"];
            this.currencyName = _data["currencyName"];
            this.regionId = _data["regionId"];
            this.imageUrl = _data["imageUrl"];
            this.currencySymbol = _data["currencySymbol"];
            if (Array.isArray(_data["mealPeriods"])) {
                this.mealPeriods = [];
                for (var _i = 0, _a = _data["mealPeriods"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.mealPeriods.push(MealPeriod.fromJS(item));
                }
            }
            this.disclaimer = _data["disclaimer"];
        }
    };
    CafeListItemViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CafeListItemViewModel();
        result.init(data);
        return result;
    };
    CafeListItemViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["timestamp"] = this.timestamp;
        data["name"] = this.name;
        data["buildingId"] = this.buildingId;
        data["buildingName"] = this.buildingName;
        data["location"] = this.location ? this.location.toJSON() : undefined;
        data["coordinates"] = this.coordinates ? this.coordinates.toJSON() : undefined;
        data["serviceHours"] = this.serviceHours;
        data["cafeId"] = this.cafeId;
        data["legacyBuildingId"] = this.legacyBuildingId;
        data["countryCode"] = this.countryCode;
        data["onlineAvailabilityCapability"] = this.onlineAvailabilityCapability;
        data["currencyName"] = this.currencyName;
        data["regionId"] = this.regionId;
        data["imageUrl"] = this.imageUrl;
        data["currencySymbol"] = this.currencySymbol;
        if (Array.isArray(this.mealPeriods)) {
            data["mealPeriods"] = [];
            for (var _i = 0, _a = this.mealPeriods; _i < _a.length; _i++) {
                var item = _a[_i];
                data["mealPeriods"].push(item.toJSON());
            }
        }
        data["disclaimer"] = this.disclaimer;
        return data;
    };
    return CafeListItemViewModel;
}());
exports.CafeListItemViewModel = CafeListItemViewModel;
var StationViewModel = /** @class */ (function () {
    function StationViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    StationViewModel.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [];
                for (var _i = 0, _a = _data["categories"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.categories.push(item);
                }
            }
            this.imageUrl = _data["imageUrl"];
            this.isAvailableOnline = _data["isAvailableOnline"];
            this.isOnlyForBetaUsers = _data["isOnlyForBetaUsers"];
            this.timeStamp = _data["timeStamp"];
        }
    };
    StationViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StationViewModel();
        result.init(data);
        return result;
    };
    StationViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (var _i = 0, _a = this.categories; _i < _a.length; _i++) {
                var item = _a[_i];
                data["categories"].push(item);
            }
        }
        data["imageUrl"] = this.imageUrl;
        data["isAvailableOnline"] = this.isAvailableOnline;
        data["isOnlyForBetaUsers"] = this.isOnlyForBetaUsers;
        data["timeStamp"] = this.timeStamp;
        return data;
    };
    return StationViewModel;
}());
exports.StationViewModel = StationViewModel;
var MenuType;
(function (MenuType) {
    MenuType["All"] = "All";
    MenuType["Offline"] = "Offline";
    MenuType["Online"] = "Online";
})(MenuType = exports.MenuType || (exports.MenuType = {}));
var ErrorResponse = /** @class */ (function () {
    function ErrorResponse(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ErrorResponse.prototype.init = function (_data) {
        if (_data) {
            this.message = _data["message"];
            this.operationId = _data["operationId"];
            this.correlationId = _data["correlationId"];
            this.subStatusCode = _data["subStatusCode"];
        }
    };
    ErrorResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ErrorResponse();
        result.init(data);
        return result;
    };
    ErrorResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["operationId"] = this.operationId;
        data["correlationId"] = this.correlationId;
        data["subStatusCode"] = this.subStatusCode;
        return data;
    };
    return ErrorResponse;
}());
exports.ErrorResponse = ErrorResponse;
var Allergen2 = /** @class */ (function () {
    function Allergen2(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Allergen2.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.optional = _data["optional"];
        }
    };
    Allergen2.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Allergen2();
        result.init(data);
        return result;
    };
    Allergen2.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["optional"] = this.optional;
        return data;
    };
    return Allergen2;
}());
exports.Allergen2 = Allergen2;
var ItemType2;
(function (ItemType2) {
    ItemType2["None"] = "None";
    ItemType2["Modifier"] = "Modifier";
    ItemType2["Item"] = "Item";
})(ItemType2 = exports.ItemType2 || (exports.ItemType2 = {}));
var Menu2 = /** @class */ (function () {
    function Menu2(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Menu2.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.stationName = _data["stationName"];
            this.stationImageUrl = _data["stationImageUrl"];
            this.dayOfWeek = _data["dayOfWeek"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(MenuItem.fromJS(item));
                }
            }
        }
    };
    Menu2.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Menu2();
        result.init(data);
        return result;
    };
    Menu2.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["stationName"] = this.stationName;
        data["stationImageUrl"] = this.stationImageUrl;
        data["dayOfWeek"] = this.dayOfWeek;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return Menu2;
}());
exports.Menu2 = Menu2;
var MenuItem = /** @class */ (function () {
    function MenuItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MenuItem.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.category = _data["category"];
            this.pricing = _data["pricing"] ? Pricing2.fromJS(_data["pricing"]) : undefined;
            this.amount = _data["amount"];
            this.imageUrl = _data["imageUrl"];
            this.calories = _data["calories"];
            if (Array.isArray(_data["options"])) {
                this.options = [];
                for (var _i = 0, _a = _data["options"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.options.push(MenuItemOptionGroup2.fromJS(item));
                }
            }
            if (Array.isArray(_data["allergens"])) {
                this.allergens = [];
                for (var _b = 0, _c = _data["allergens"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.allergens.push(Allergen2.fromJS(item));
                }
            }
        }
    };
    MenuItem.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MenuItem();
        result.init(data);
        return result;
    };
    MenuItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["category"] = this.category;
        data["pricing"] = this.pricing ? this.pricing.toJSON() : undefined;
        data["amount"] = this.amount;
        data["imageUrl"] = this.imageUrl;
        data["calories"] = this.calories;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (var _i = 0, _a = this.options; _i < _a.length; _i++) {
                var item = _a[_i];
                data["options"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.allergens)) {
            data["allergens"] = [];
            for (var _b = 0, _c = this.allergens; _b < _c.length; _b++) {
                var item = _c[_b];
                data["allergens"].push(item.toJSON());
            }
        }
        return data;
    };
    return MenuItem;
}());
exports.MenuItem = MenuItem;
var MenuItemOption2 = /** @class */ (function () {
    function MenuItemOption2(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MenuItemOption2.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.price = _data["price"] ? Pricing2.fromJS(_data["price"]) : undefined;
            this.itemType = _data["itemType"];
            if (Array.isArray(_data["optionGroup"])) {
                this.optionGroup = [];
                for (var _i = 0, _a = _data["optionGroup"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.optionGroup.push(MenuItemOptionGroup2.fromJS(item));
                }
            }
        }
    };
    MenuItemOption2.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MenuItemOption2();
        result.init(data);
        return result;
    };
    MenuItemOption2.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["price"] = this.price ? this.price.toJSON() : undefined;
        data["itemType"] = this.itemType;
        if (Array.isArray(this.optionGroup)) {
            data["optionGroup"] = [];
            for (var _i = 0, _a = this.optionGroup; _i < _a.length; _i++) {
                var item = _a[_i];
                data["optionGroup"].push(item.toJSON());
            }
        }
        return data;
    };
    return MenuItemOption2;
}());
exports.MenuItemOption2 = MenuItemOption2;
var MenuItemOptionGroup2 = /** @class */ (function () {
    function MenuItemOptionGroup2(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MenuItemOptionGroup2.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.price = _data["price"] ? Pricing2.fromJS(_data["price"]) : undefined;
            this.amount = _data["amount"];
            this.itemType = _data["itemType"];
            this.groupType = _data["groupType"];
            this.minimum = _data["minimum"];
            this.maximum = _data["maximum"];
            this.isSingleSelect = _data["isSingleSelect"];
            if (Array.isArray(_data["options"])) {
                this.options = [];
                for (var _i = 0, _a = _data["options"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.options.push(MenuItemOption2.fromJS(item));
                }
            }
        }
    };
    MenuItemOptionGroup2.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MenuItemOptionGroup2();
        result.init(data);
        return result;
    };
    MenuItemOptionGroup2.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["price"] = this.price ? this.price.toJSON() : undefined;
        data["amount"] = this.amount;
        data["itemType"] = this.itemType;
        data["groupType"] = this.groupType;
        data["minimum"] = this.minimum;
        data["maximum"] = this.maximum;
        data["isSingleSelect"] = this.isSingleSelect;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (var _i = 0, _a = this.options; _i < _a.length; _i++) {
                var item = _a[_i];
                data["options"].push(item.toJSON());
            }
        }
        return data;
    };
    return MenuItemOptionGroup2;
}());
exports.MenuItemOptionGroup2 = MenuItemOptionGroup2;
/** View model for a menu that is available for online ordering.            This will eventually be replaced with V2 models that require less properties. */
var OnlineMenu = /** @class */ (function () {
    function OnlineMenu(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OnlineMenu.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.stationId = _data["stationId"];
            this.stationName = _data["stationName"];
            this.stationImageUrl = _data["stationImageUrl"];
            this.dayOfWeek = _data["dayOfWeek"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(OnlineMenuItem.fromJS(item));
                }
            }
        }
    };
    OnlineMenu.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OnlineMenu();
        result.init(data);
        return result;
    };
    OnlineMenu.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["stationId"] = this.stationId;
        data["stationName"] = this.stationName;
        data["stationImageUrl"] = this.stationImageUrl;
        data["dayOfWeek"] = this.dayOfWeek;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return OnlineMenu;
}());
exports.OnlineMenu = OnlineMenu;
/** View model for a menu item that is available for order online.            This will eventually be replaced with V2 models that don't require inheritance from Domain.MenuItem. */
var OnlineMenuItem = /** @class */ (function () {
    function OnlineMenuItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OnlineMenuItem.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.isAvailableOnline = _data["isAvailableOnline"];
            this.stationId = _data["stationId"];
            this.timeToLiveInSeconds = _data["timeToLiveInSeconds"];
            this.itemId = _data["itemId"];
            this.menuId = _data["menuId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.category = _data["category"];
            this.imageUrl = _data["imageUrl"];
            this.pricing = _data["pricing"] ? Pricing.fromJS(_data["pricing"]) : undefined;
            this.amount = _data["amount"];
            this.canPurchaseOnline = _data["canPurchaseOnline"];
            this.legacyCafeMenuId = _data["legacyCafeMenuId"];
            this.vendorId = _data["vendorId"];
            this.vendorSourceRecordId = _data["vendorSourceRecordId"];
            this.quantityLimitPerCustomer = _data["quantityLimitPerCustomer"];
            if (Array.isArray(_data["options"])) {
                this.options = [];
                for (var _i = 0, _a = _data["options"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.options.push(MenuItemOptionGroup.fromJS(item));
                }
            }
            this.calories = _data["calories"];
            if (Array.isArray(_data["allergens"])) {
                this.allergens = [];
                for (var _b = 0, _c = _data["allergens"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.allergens.push(Allergen.fromJS(item));
                }
            }
            this.timeStamp = _data["timeStamp"];
        }
    };
    OnlineMenuItem.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OnlineMenuItem();
        result.init(data);
        return result;
    };
    OnlineMenuItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isAvailableOnline"] = this.isAvailableOnline;
        data["stationId"] = this.stationId;
        data["timeToLiveInSeconds"] = this.timeToLiveInSeconds;
        data["itemId"] = this.itemId;
        data["menuId"] = this.menuId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["category"] = this.category;
        data["imageUrl"] = this.imageUrl;
        data["pricing"] = this.pricing ? this.pricing.toJSON() : undefined;
        data["amount"] = this.amount;
        data["canPurchaseOnline"] = this.canPurchaseOnline;
        data["legacyCafeMenuId"] = this.legacyCafeMenuId;
        data["vendorId"] = this.vendorId;
        data["vendorSourceRecordId"] = this.vendorSourceRecordId;
        data["quantityLimitPerCustomer"] = this.quantityLimitPerCustomer;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (var _i = 0, _a = this.options; _i < _a.length; _i++) {
                var item = _a[_i];
                data["options"].push(item.toJSON());
            }
        }
        data["calories"] = this.calories;
        if (Array.isArray(this.allergens)) {
            data["allergens"] = [];
            for (var _b = 0, _c = this.allergens; _b < _c.length; _b++) {
                var item = _c[_b];
                data["allergens"].push(item.toJSON());
            }
        }
        data["timeStamp"] = this.timeStamp;
        return data;
    };
    return OnlineMenuItem;
}());
exports.OnlineMenuItem = OnlineMenuItem;
var PatchOrderRequest = /** @class */ (function () {
    function PatchOrderRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PatchOrderRequest.prototype.init = function (_data) {
        if (_data) {
            this.orderStatus = _data["orderStatus"];
        }
    };
    PatchOrderRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PatchOrderRequest();
        result.init(data);
        return result;
    };
    PatchOrderRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["orderStatus"] = this.orderStatus;
        return data;
    };
    return PatchOrderRequest;
}());
exports.PatchOrderRequest = PatchOrderRequest;
var Pricing2 = /** @class */ (function () {
    function Pricing2(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Pricing2.prototype.init = function (_data) {
        if (_data) {
            this.currencyUnit = _data["currencyUnit"];
            this.amount = _data["amount"];
        }
    };
    Pricing2.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Pricing2();
        result.init(data);
        return result;
    };
    Pricing2.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["currencyUnit"] = this.currencyUnit;
        data["amount"] = this.amount;
        return data;
    };
    return Pricing2;
}());
exports.Pricing2 = Pricing2;
var CafeConfigResponse = /** @class */ (function () {
    function CafeConfigResponse(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CafeConfigResponse.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.vendorSourceId = _data["vendorSourceId"];
            this.timestamp = _data["timestamp"];
            this.isOffline = _data["isOffline"];
            this.isOnlyForBetaUsers = _data["isOnlyForBetaUsers"];
        }
    };
    CafeConfigResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CafeConfigResponse();
        result.init(data);
        return result;
    };
    CafeConfigResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["vendorSourceId"] = this.vendorSourceId;
        data["timestamp"] = this.timestamp;
        data["isOffline"] = this.isOffline;
        data["isOnlyForBetaUsers"] = this.isOnlyForBetaUsers;
        return data;
    };
    return CafeConfigResponse;
}());
exports.CafeConfigResponse = CafeConfigResponse;
var ErrorResponse2 = /** @class */ (function () {
    function ErrorResponse2(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ErrorResponse2.prototype.init = function (_data) {
        if (_data) {
            this.message = _data["message"];
            this.statusCode = _data["statusCode"];
            this.subStatusCode = _data["subStatusCode"];
        }
    };
    ErrorResponse2.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ErrorResponse2();
        result.init(data);
        return result;
    };
    ErrorResponse2.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["statusCode"] = this.statusCode;
        data["subStatusCode"] = this.subStatusCode;
        return data;
    };
    return ErrorResponse2;
}());
exports.ErrorResponse2 = ErrorResponse2;
var SubStatusCode2;
(function (SubStatusCode2) {
    SubStatusCode2["InvalidCartItems"] = "InvalidCartItems";
    SubStatusCode2["InvalidSemantics"] = "InvalidSemantics";
    SubStatusCode2["StationNotFound"] = "StationNotFound";
    SubStatusCode2["UserProfileNotFound"] = "UserProfileNotFound";
    SubStatusCode2["CafeNotFound"] = "CafeNotFound";
    SubStatusCode2["CustomerRestricted"] = "CustomerRestricted";
    SubStatusCode2["CartWrongLocation"] = "CartWrongLocation";
    SubStatusCode2["CartNotFound"] = "CartNotFound";
    SubStatusCode2["MismatchedSubtotal"] = "MismatchedSubtotal";
    SubStatusCode2["InvalidSubtotalFromVendor"] = "InvalidSubtotalFromVendor";
    SubStatusCode2["PaymentRejected"] = "PaymentRejected";
    SubStatusCode2["AddedInvalidCartItemToCart"] = "AddedInvalidCartItemToCart";
    SubStatusCode2["PaymentServiceCallFailed"] = "PaymentServiceCallFailed";
    SubStatusCode2["OrderNotFound"] = "OrderNotFound";
    SubStatusCode2["OrderNotReadyForPickup"] = "OrderNotReadyForPickup";
    SubStatusCode2["WrongVendorId"] = "WrongVendorId";
    SubStatusCode2["CafeConfigIdNotFound"] = "CafeConfigIdNotFound";
    SubStatusCode2["VendorSourceRecordNotFound"] = "VendorSourceRecordNotFound";
    SubStatusCode2["UserNotAuthorizedToSyncCafes"] = "UserNotAuthorizedToSyncCafes";
})(SubStatusCode2 = exports.SubStatusCode2 || (exports.SubStatusCode2 = {}));
var FoodStallCreate = /** @class */ (function () {
    function FoodStallCreate(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FoodStallCreate.prototype.init = function (_data) {
        if (_data) {
            this.description = _data["description"];
            this.externalLinkUri = _data["externalLinkUri"];
            this.name = _data["name"];
            if (Array.isArray(_data["schedules"])) {
                this.schedules = [];
                for (var _i = 0, _a = _data["schedules"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.schedules.push(FoodStallSchedule.fromJS(item));
                }
            }
        }
    };
    FoodStallCreate.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FoodStallCreate();
        result.init(data);
        return result;
    };
    FoodStallCreate.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["externalLinkUri"] = this.externalLinkUri;
        data["name"] = this.name;
        if (Array.isArray(this.schedules)) {
            data["schedules"] = [];
            for (var _i = 0, _a = this.schedules; _i < _a.length; _i++) {
                var item = _a[_i];
                data["schedules"].push(item.toJSON());
            }
        }
        return data;
    };
    return FoodStallCreate;
}());
exports.FoodStallCreate = FoodStallCreate;
var FoodStallResponse = /** @class */ (function () {
    function FoodStallResponse(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FoodStallResponse.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.imageUri = _data["imageUri"];
            this.externalLinkUri = _data["externalLinkUri"];
            this.name = _data["name"];
            if (Array.isArray(_data["schedules"])) {
                this.schedules = [];
                for (var _i = 0, _a = _data["schedules"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.schedules.push(FoodStallSchedule.fromJS(item));
                }
            }
        }
    };
    FoodStallResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FoodStallResponse();
        result.init(data);
        return result;
    };
    FoodStallResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["imageUri"] = this.imageUri;
        data["externalLinkUri"] = this.externalLinkUri;
        data["name"] = this.name;
        if (Array.isArray(this.schedules)) {
            data["schedules"] = [];
            for (var _i = 0, _a = this.schedules; _i < _a.length; _i++) {
                var item = _a[_i];
                data["schedules"].push(item.toJSON());
            }
        }
        return data;
    };
    return FoodStallResponse;
}());
exports.FoodStallResponse = FoodStallResponse;
var FoodStallSchedule = /** @class */ (function () {
    function FoodStallSchedule(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.location = new Location();
        }
    }
    FoodStallSchedule.prototype.init = function (_data) {
        if (_data) {
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : new Location();
            this.startsOn = _data["startsOn"];
            this.endsOn = _data["endsOn"];
        }
    };
    FoodStallSchedule.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FoodStallSchedule();
        result.init(data);
        return result;
    };
    FoodStallSchedule.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location ? this.location.toJSON() : undefined;
        data["startsOn"] = this.startsOn;
        data["endsOn"] = this.endsOn;
        return data;
    };
    return FoodStallSchedule;
}());
exports.FoodStallSchedule = FoodStallSchedule;
var FoodStallUpdate = /** @class */ (function () {
    function FoodStallUpdate(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FoodStallUpdate.prototype.init = function (_data) {
        if (_data) {
            this.description = _data["description"];
            this.externalLinkUri = _data["externalLinkUri"];
            this.name = _data["name"];
            if (Array.isArray(_data["schedules"])) {
                this.schedules = [];
                for (var _i = 0, _a = _data["schedules"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.schedules.push(FoodStallSchedule.fromJS(item));
                }
            }
        }
    };
    FoodStallUpdate.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FoodStallUpdate();
        result.init(data);
        return result;
    };
    FoodStallUpdate.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["externalLinkUri"] = this.externalLinkUri;
        data["name"] = this.name;
        if (Array.isArray(this.schedules)) {
            data["schedules"] = [];
            for (var _i = 0, _a = this.schedules; _i < _a.length; _i++) {
                var item = _a[_i];
                data["schedules"].push(item.toJSON());
            }
        }
        return data;
    };
    return FoodStallUpdate;
}());
exports.FoodStallUpdate = FoodStallUpdate;
var Location = /** @class */ (function () {
    function Location(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Location.prototype.init = function (_data) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    };
    Location.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Location();
        result.init(data);
        return result;
    };
    Location.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    };
    return Location;
}());
exports.Location = Location;
var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["Sunday"] = "Sunday";
    DayOfWeek["Monday"] = "Monday";
    DayOfWeek["Tuesday"] = "Tuesday";
    DayOfWeek["Wednesday"] = "Wednesday";
    DayOfWeek["Thursday"] = "Thursday";
    DayOfWeek["Friday"] = "Friday";
    DayOfWeek["Saturday"] = "Saturday";
})(DayOfWeek = exports.DayOfWeek || (exports.DayOfWeek = {}));
var ApiException = /** @class */ (function (_super) {
    __extends(ApiException, _super);
    function ApiException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isApiException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    ApiException.isApiException = function (obj) {
        return obj.isApiException === true;
    };
    return ApiException;
}(Error));
exports.ApiException = ApiException;
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
//# sourceMappingURL=api-client.js.map